
import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup,FormsModule, Validators, FormBuilder } from '@angular/forms';
import { ServerService } from '../services/server.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2'

import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { timeStamp } from 'console';

declare var $:any;
const incr = 1;
declare var iziToast:any;

@Component({
  selector: 'app-admin-setting',
  templateUrl: './admin-setting.component.html',
  styleUrls: ['./admin-setting.component.css']
})
export class AdminSettingComponent implements OnInit {
  radio: any;
  comp_name: any;fusername :any;fpassword:any;furl:any;flicense:any;
  formData: any;
  addAadmin: FormGroup;
  reseller_value;inst_wp_upd_unoff;admins;
  recordNotFound = false;
  prodrecordNotFound = false;
  demorecordNotFound = false;
  notesrecordNotFound = false;
  avail_license;
  progstatus: string;queue_list;reseller_sets = false;
  editAdmin: FormGroup;addNodeAadmin: FormGroup;
  editmrvoipAdmin: FormGroup;
  old_sip_url;admin_id;
  has_contacts;
  admin_statuss;
  has_smss;
  masterSelected:boolean;
  has_chats;
  has_whatsapps;
  check_data;
  has_chatbots;
  selected = 1;
  admin_user_name;
  password;
  select_all;
  days;
  reports;
  list_report;
  faxuser = false;
  automation_value;
  select_all_apis;
  show_all_sel = true;
  inst_wp_upd;inst_wp_add;wp_inst_edit;wp_type_edit;inst_wp_add_unoff;
  reportChecked;
  price_sms_upd;price_sms_add;smsTariffs;sms_price_edit;  device_type = [{'status':'1'},{'status':'0'}]
  company_name;
  noteseminder_company_name;
  noteseminder_notes;
  list_wpinst;list_allwpinst;
  get_notes;
  wp_count;adminlists;resellerChecked;
  admin;
  id;
  mrvoip_apisChecked;
  api_paid;
  price_sms_postpaid=true;
  showCallTariffsDetEdit;
  showCallTariffsDet;
  showDomainName;
  callTariffs;
  editShippingAddresss = false;
  pdfurl;
  sso: number;
  notes: any;
  notes1 = false;
  notes_valid = false;
  mrvoip_license: any;
  solicense = false;
  show_admin_error = false;
  reportsvalue:any = [];
  options;
  mrvoip_paid : any = [];
  mrvoip_v:any = [];
  all_apis_data;
  mrvoip_api;
  mrvoip_paid_api;
  line_access = false;
  line_Access_token;
  check_api_date;
  updat_id;
  dates : FormGroup;
  set_dates_single : FormGroup;
  update_date = false;
  adminProduction:any;
  adminDemo:any;
  selall;
  selectedIndex:any;
  togleval;
  comment_status;
  constructor(private serverService: ServerService,private route: ActivatedRoute,private router:Router,private sanitizer: DomSanitizer) { 
this.masterSelected= false;
  }

   progress1 = 0;
  ngOnInit() {
this.dates = new FormGroup({
  'to_dt' : new FormControl(null),
})
    // var options = '[{"name":"Make Call","value":"call_make"},{"name":"Pickup Call","value":"call_pickup"},{"name":"Divert Call","value":"call_divert"},{"name":"Divert Voicemail","value":"vm_divert"},{"name":"Listen","value":"call_listen"},{"name":"Whisper","value":"call_whisper"},{"name":"Bargein","value":"call_bargein"},{"name":"Start Call Record","value":"record_start"},{"name":"Stop Call Record","value":"record_stop"},{"name":"Join Call","value":"call_join"}]';
    // var options = '[{"name":"Make Call","value":"call_make"},{"name":"Pickup Call","value":"call_pickup"},{"name":"Divert Call","value":"call_divert"},{"name":"Divert Voicemail","value":"vm_divert"},{"name":"Listen","value":"call_listen"},{"name":"Whisper","value":"call_whisper"},{"name":"Bargein","value":"call_bargein"},{"name":"Start Call Record","value":"record_start"},{"name":"Stop Call Record","value":"record_stop"},{"name":"Join Call","value":"call_join"},{"name":"Transfer call","value":"call_transfer"},{"name":"Drop Call","value":"call_drop"},{"name":"Add Agent","value":"add_agent"},{"name":"Update Agent","value":"update_agent"},{"name":"Delete Agent","value":"delete_agent"},{"name":"Query Extension","value":"query_extension"},{"name":"Hotel Module","value":"hm_update_extension"}]';
// this.get_all_apis();
    // this.options = JSON.parse(options)
    console.log()
 
     var userId = localStorage.getItem('userId');
    var reseller = localStorage.getItem('reseller');
    console.log(reseller);
    this.reseller_value=localStorage.getItem('reseller');
   
    if(userId == '1'  || (reseller != '' || reseller != null|| reseller !=undefined) ){

    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'You have no access view that page!',
      });
      this.router.navigate(['/'])
      return false;
    }
    // Password Validation
    $("#add_admin_password").keydown(function (e) {
  
      console.log(e.which); 
      if(e.which == 32){
              iziToast.warning({
                message: "Sorry, Whitespace not allowed",
                position: 'topRight'
            }); 
            return false;
      }
      return e.which !== 32;
});
$("#user_name").keydown(function (e) {
  
  console.log(e.which); 
  if(e.which == 32){
          iziToast.warning({
            message: "Sorry, Whitespace not allowed",
            position: 'topRight'
        }); 
        return false;
  }
  return e.which !== 32;
});
$("#add_company_name").keydown(function (e) {
  
  console.log(e.which); 
  if(e.which == 32){
          iziToast.warning({
            message: "Sorry, Whitespace not allowed",
            position: 'topRight'
        }); 
        return false;
  }
  return e.which !== 32;
});


     this.addAadmin = new FormGroup({
       'omni':new FormControl(0),
       
      'admin_name' : new FormControl(null,Validators.required),
      'pbx_count' : new FormControl(null),
      'agent_count' : new FormControl(null),
      'user_name' : new FormControl(null),
       'add_admin_password' : new FormControl(null,Validators.required),
      'whatsapp_num' : new FormControl(null),
      'company_name' : new FormControl(null,Validators.required),
      'domain_name' : new FormControl(null),
      'has_contact' : new FormControl(0),
      'voice_3cx' : new FormControl(0),
      'predective_dialer' : new FormControl(0),
      'survey_vid': new FormControl(0),
      'lead' : new FormControl(0),
        'has_sms' : new FormControl(0),
        'has_mrvoipconnection' : new FormControl(0),
        'has_chat' : new FormControl(0),
        'has_whatsapp' : new FormControl(0),
        'has_chatbot' : new FormControl(0),
        'has_fb' : new FormControl(0),
        'has_fax' : new FormControl(0),
        'has_wechat' : new FormControl(0), 
        'has_telegram' : new FormControl(0),
        'has_internal_ticket' : new FormControl(0),
        'has_external_ticket' : new FormControl(0),
        'has_internal_chat' : new FormControl(0),
        'baisc_wallboard' : new FormControl(0),
        'wallboard_one' : new FormControl(0),
        'wallboard_two' : new FormControl(0),
        'wallboard_three' : new FormControl(0),
        'wallboard_four' : new FormControl(0),
        'wallboard_five' : new FormControl(0),
        'wallboard_six' : new FormControl(0),
        'wallboard_eight' : new FormControl(0),
        'wallboard_nine' : new FormControl(0),
        'wallboard_ten' : new FormControl(0),
        'two_factor' : new FormControl(0),
        'admin_status' : new FormControl(0),
        'notes' : new FormControl(null),
        'a_has_sms_postpaid':new FormControl(0),
        'has_webinar' : new FormControl(0),
        'has_queue' : new FormControl(0),
        'has_rec_manage' : new FormControl(0),
        'has_sso' : new FormControl(0),
        'has_teams': new FormControl(0),
        'zoho_phone': new FormControl(0),
        'mrvoip_license': new FormControl(0),
        
     });


     this.addNodeAadmin = new FormGroup({
      'admin_name' : new FormControl(null,Validators.required),
      'pbx_count' : new FormControl(null),
      'agent_count' : new FormControl(null),
      // 'user_name' : new FormControl(null),
      // 'user_password' : new FormControl(null,Validators.required),
      'whatsapp_num' : new FormControl(null),
      // 'company_name' : new FormControl(null,Validators.required),
      'domain_name' : new FormControl(null),
      'has_contact' : new FormControl(0),
      'voice_3cx' : new FormControl(0),
      'predective_dialer' : new FormControl(0),
      'survey_vid': new FormControl(0),
      'lead' : new FormControl(0),
        'has_sms' : new FormControl(0),
        'has_mrvoipconnection' : new FormControl(0),
        'has_chat' : new FormControl(0),
        'has_whatsapp' : new FormControl(0),
        'has_chatbot' : new FormControl(0),
        'has_fb' : new FormControl(0),
        'has_fax' : new FormControl(0),
        'has_wechat' : new FormControl(0), 
        'has_telegram' : new FormControl(0),
        'has_internal_ticket' : new FormControl(0),
        'has_external_ticket' : new FormControl(0),
        'has_internal_chat' : new FormControl(0),
        'baisc_wallboard' : new FormControl(0),
        'wallboard_one' : new FormControl(0),
        'wallboard_two' : new FormControl(0),
        'wallboard_three' : new FormControl(0),
        'wallboard_four' : new FormControl(0),
        'wallboard_five' : new FormControl(0),
        'wallboard_six' : new FormControl(0),
        'wallboard_eight' : new FormControl(0),
        'wallboard_ten' : new FormControl(0),
        'two_factor' : new FormControl(0),
        'admin_status' : new FormControl(0),
        'notes' : new FormControl(null),
        'a_has_sms_postpaid':new FormControl(0),
        'has_webinar' : new FormControl(0),
        'has_queue' : new FormControl(0),
        'has_rec_manage' : new FormControl(0),
        
     });
     this.set_dates_single = new FormGroup({
      'to_dts' : new FormControl(null),
     })
  // this.editmrvoipAdmin = new FormGroup({
  //   'mrvoip_apis' : new FormControl(null),
  // })
      this.editAdmin= new FormGroup({
        'admin_name' : new FormControl(null,Validators.required),
// for billing ---
        'user_id' : new FormControl(null),
// ----
        'pbx_count' : new FormControl(null),
        'agent_count' : new FormControl(null),
        'company_name' : new FormControl(null),
        'whatsapp_num' : new FormControl(null),
        'domain_name' : new FormControl(null),
        'has_contact' : new FormControl(0),
        'voice_3cx' : new FormControl(0),
        'predective_dialer' : new FormControl(0),
        'survey_vid': new FormControl(0),
        'lead' : new FormControl(0),
        'has_sms' : new FormControl(0),
        'has_mrvoipconnection' : new FormControl(0),
        'has_chat' : new FormControl(0),
        'has_whatsapp' : new FormControl(0),
        'has_chatbot' : new FormControl(0),
        'has_fb' : new FormControl(0),
        'has_fax' : new FormControl(0),
        'has_wechat' : new FormControl(0),
        'has_telegram' : new FormControl(0),
        'has_internal_ticket' : new FormControl(0),
        'has_external_ticket' : new FormControl(0),
        'has_internal_chat' : new FormControl(0),
        'baisc_wallboard' : new FormControl(0),
        'wallboard_one' : new FormControl(0),
        'wallboard_two' : new FormControl(0),
        'wallboard_three' : new FormControl(0),
        'wallboard_four' : new FormControl(0),
        'wallboard_five' : new FormControl(0),
        'wallboard_six' : new FormControl(0),
        'wallboard_eight' : new FormControl(0),
        'wallboard_nine' : new FormControl(0),
        'wallboard_ten' : new FormControl(0),
        'two_factor' : new FormControl(0),
        'admin_status' : new FormControl(0),
        'notes' : new FormControl(null),
        'a_has_sms_postpaid_upd':new FormControl(0),
        'has_webinar' : new FormControl(0),
        'has_queue' : new FormControl(0),
        'has_rec_manage' : new FormControl(0),
         'has_sso' : new FormControl(0),
         'has_teams' : new FormControl(0),
         'zoho_phone': new FormControl(0),
         'has_survey': new FormControl(0),
         'mrvoip_license': new FormControl(0),
         'restrict_admin': new FormControl(0),

         'cli_creation': new FormControl(0),
         'line_token' : new FormControl(null),
           });

           this.listReports();
           this.getwpinsts();   
          
     this.admin_settings();
     this.productionAdminSettings();
     this.demoAdminSettings();
     this.getNotes();
     this.getTariffsList();
     this.getalladmins();
     this.getcalltariffs();
     this.getNodelicense();
     this.free_apis();

     $(".hit_n").keyup(function(event) {
      if (event.keyCode === 13) {
        $("#select_permission").click();
      }
    }); 

  }
  // get_all_apis(){
  //   let api_req: any = '{"operation":"power_bi", "moduleType":"power_bi", "api_type": "web", "element_data":{"action":"get_paid_apis"}}';
  //   this.serverService.sendServer(api_req).subscribe((response:any)=>{
  //     if(response.result.status==true){
  //       this.options = response.result.data;
  //       var k = [];
  //       this.options.forEach(element => {
  //         k.push(element.api_value);
  //       });
  //       this.all_apis_data = k.join(',');
      
  //     }
  //   })
  // }
  get_dates(){
    let api_reqs: any = '{"operation":"power_bi", "moduleType":"power_bi", "api_type": "web", "element_data":{"action":"get_paid_apis"}}';
    this.serverService.welcomeEmailMrvoip(api_reqs,this.company_name).subscribe((response:any)=>{
      this.options = response.result.data;
      var k = [];
      this.options.forEach(element => {
        k.push(element.api_value);
      });
      this.all_apis_data = k.join(',');
console.log(response)
    })
  }
  date_time(){
let api_req:any = '{"operation":"power_bi", "moduleType":"power_bi", "api_type": "web", "element_data":{"action":"set_date","to_date":"'+this.dates.value.to_dt+'","id":"'+this.id+'","api_value":"'+this.check_api_date+'"}}';
console.log(api_req);
this.serverService.sendServer(api_req).subscribe((response:any)=>{
if(response.result.status==true){
  if(response.result.data==1){
    $("#edit_adminform1").modal("hide");
    iziToast.success({
      message: "Date Updated Successfully",
      position: 'topRight'
  });
  }else{
    iziToast.error({
      message: "Sorry,some error occure",
      position: 'topRight'
  });
  }
}
})
  }

  
  // apis_data(){
  //   let api_req:any='{"operation":"agents","moduleType":"agents","api_type":"web","element_data":{"action":"get_mrvoip_apis"}}';
  //   this.serverService.sendServer(api_req).subscribe((response:any)=>{
  //     if(response.result.data!=''){
  //       this.options = response.result.data;
  //     }
  //   })
  // }
  GetapiStats(email:string, isChecked: boolean,apivalue){
    console.log(email);
    console.log(isChecked);
      if(isChecked) {
      this.mrvoip_paid.push(email);
        
    } else {
      const index = this.mrvoip_paid.findIndex(el => el === email)
      if (index > -1) {
        this.mrvoip_paid.splice(index, 1);
      }

    }

    // if(apivalue!=''){
    //   let api_req:any = '{"operation":"power_bi", "moduleType":"power_bi", "api_type": "web", "element_data":{"action":"change_perchase","id":"'+this.id+'","api_value":"'+apivalue+'"}}';
    //   this.serverService.sendServer(api_req).subscribe((response:any)=>{
    //     if(response.result.status==true){
    //       console.log(response);
    //     }
    //   })
    // }

    console.log(this.mrvoip_paid);
  }
  // select_all(){
  //   for(var i=0; i<this.options.length; i++){
  //     this.options.push(this.options[i].api_value);
  //   }
  // }
  // checkUncheckAll() {
  //   $('.select_all').map(function() {return this.options.api_value;}).get().join(',')
  //   // this.getCheckedItemList();
  // }
  // getCheckedItemList(){
  //   this.options = [];
  //   for (var i = 0; i < this.options.length; i++) {
  //     if(this.checklist[i].isSelected)
  //     this.checkedList.push(this.checklist[i]);
  //   }
  //   this.checkedList = JSON.stringify(this.checkedList);
  // }
  // slectAll(){
  //   // alert("sjd");
  //   if($("#select_All").prop("checked")) {
  //     // this.isSelected= true;
  //     $(".mrvoip_one").prop("checked", true);
  // } else {
  //   // this.isSelected= false;
  
  //     $(".mrvoip_one").prop("checked", false);
  // } 
  // }
  free_apis(){
    let api_req:any='{"operation":"power_bi", "moduleType":"power_bi", "api_type": "web", "element_data":{"action":"get_free_apis"}}';
    this.serverService.sendServer(api_req).subscribe((response:any)=>{
if(response.result.status==true){
  this.mrvoip_api = response.result.data[0].api;
  this.mrvoip_paid_api = response.result.data[0].api_id
}
    })
  }
  slectAll(eve: boolean){

    if(eve) {
      this.selall = true;
      this.show_all_sel = true;
            $(".mrvoip_one").prop("checked", true);
           $("#edit_adminform1").modal("show");
          var sel_all = [];
          // var id = [];
          // this.options.forEach(element=>{
          //   sel_all.push(element.api_value);
          //   id.push(element.id);
          // })
          console.log(this.options);
          this.options.forEach((element, index) => {
            const num2 = this.all_apis_data[index];
            // const num23 = this.mrvoip_paid[index];
            console.log(num2)
            // console.log(num23);
            console.log(element);
            // if(element.api_value.toLowerCase() != num2.toLowerCase()){
            if(element.api_value != num2){
              sel_all.push(element.api_value);
            }
            // if(element.id != num23){
            //   id.push(element.id);
            // }
          });
          // var paid_status = id;
          var select = sel_all;
          this.select_all_apis = select;
          console.log(this.select_all_apis);
          console.log(this.mrvoip_v);
          // this.mrvoip_v = [];
          // this.mrvoip_paid = [];
           // this.mrvoip_v = [];
      //     this.mrvoip_paid = [];
          // this.mrvoip_v.push(select);
          // this.mrvoip_paid.push(paid_status);
          // this.mrvoip_paid = paid_status;
          this.mrvoip_v = select;
        // console.log(this.mrvoip_v);
        // console.log(this.mrvoip_paid)
      } else {
        this.selall = false;
        // this.select_all = 0;
        // this.isSelected= false;
          // $(".mrvoip_one").prop("checked", false);
          // $(".toggle").prop("checked",false);
          this.mrvoip_v = [];
          this.mrvoip_paid = [];
          this.mrvoip_v = this.mrvoip_api;
          this.mrvoip_paid = this.mrvoip_paid_api;
          console.log(this.mrvoip_api)
          console.log(this.mrvoip_paid_api)
          console.log(this.mrvoip_v);
        console.log(this.mrvoip_paid)
      } 
   
  }
  setdate_time(){
    if(this.set_dates_single.value.to_dts==''){
    this.update_date = true;
    iziToast.warning({
      message: "Please Set Expired Date",
      position: 'topRight'
  }); 
    return false;
    }else{
      this.update_date = false;
    }
    let api:any = '{"operation":"power_bi", "moduleType":"power_bi", "api_type": "web", "element_data":{"action":"add_single_api_date","api_value":"'+this.check_api_date+'","api_id":"'+this.updat_id+'","to_date":"'+this.set_dates_single.value.to_dts+'","admin_id":"'+this.id+'"}}';
    console.log(api);
    this.serverService.sendServer(api).subscribe((response:any)=>{
      if(response.result.status==true){
        this.get_dates();
        console.log(response);
        $("#set_date").modal("hide");
      }
    })
  }
  GetStats(email:string,id, isChecked: boolean) {
    console.log(id)
    console.log(email);
    console.log(isChecked);
    this.check_api_date = email;
    this.updat_id = id;
      if(isChecked) {
      this.mrvoip_v.push(email);
      console.log(this.check_api_date)
        this.GetapiStats(id, true, email);
        $("#set_date").modal("show");
    } else {
      const index = this.mrvoip_v.findIndex(el => el === email)
      if (index > -1) {
        this.mrvoip_v.splice(index, 1);
      }
        this.show_all_sel = false;
          let api:any = '{"operation":"power_bi", "moduleType":"power_bi", "api_type": "web", "element_data":{"action":"single_api_date","api_value":"'+this.check_api_date+'","api_id":"'+this.updat_id+'","to_date":"0000-00-00","admin_id":"'+this.id+'"}}';
      console.log(api);
      this.serverService.sendServer(api).subscribe((response:any)=>{
        if(response.result.status==true){
          this.get_dates();
          // var k = [];
          // k = this.options.find(item => item.api_value == this.check_api_date)
          // console.log(k)
          // console.log(k['days']);
          // if(k['days']!=''){
          //   this.options.map(item =>{
          //     return {'' : item.days}
          //   })
          // }
          // console.log(this.options)
          // console.log(response);
          $("#set_date").modal("hide");
        }
      })
      
    }


    console.log(this.mrvoip_v);
}
  

  getNodelicense(){
    let access_token: any=localStorage.getItem('access_token');
    let api_req:any = '{"operation":"agents", "moduleType":"agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"get_avail_license_key"}}';
    this.serverService.sendServer(api_req).subscribe((response:any) => {
      if(response.status == true){
      this.avail_license = response.result.data;
      }
    }, 
    (error)=>{
      console.log(error);
    });
  }
  getTariffsList(){
    let access_token: any=localStorage.getItem('access_token');
    let api_req:any = '{"operation":"wpchat", "moduleType":"wpchat", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"view_tarrif"}}';
    this.serverService.sendServer(api_req).subscribe((response:any) => {
      if(response.status == true){
      this.smsTariffs = response.result.data.plans;
      } else {
      }
    }, 
    (error)=>{
      console.log(error);
    });
    }
    listReports(){
      let access_token: any=localStorage.getItem('access_token');
      let uadmin_id: any=localStorage.getItem('userId');
    
      let api_req:any = '{"operation":"agents", "moduleType": "agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"list_report","user_id":"'+uadmin_id+'"}}';
    
      this.serverService.sendServer(api_req).subscribe((response:any) => {
        if(response.status==true){
          this.list_report = response.result.data;
        } 
      }, 
      (error)=>{
          console.log(error);
      });
    }
    getwpinsts(){
      let access_token: any=localStorage.getItem('access_token');
      let uadmin_id: any=localStorage.getItem('userId');
    
      let api_req:any = '{"operation":"agents", "moduleType": "agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"getInstanceDetails"}}';
    
      this.serverService.sendServer(api_req).subscribe((response:any) => {
        if(response.status==true){
          this.list_wpinst = response.result.data;
        } 
      }, 
      (error)=>{
          console.log(error);
      });
    }
    getallwpinsts(id){

      let access_token: any=localStorage.getItem('access_token');
      let api_req:any = '{"operation":"agents", "moduleType": "agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"getallInstanceDetails","admin_id":"'+id+'"}}';
    
      this.serverService.sendServer(api_req).subscribe((response:any) => {
        if(response.status==true){
          this.list_allwpinst = response.result.data;
        } 
      }, 
      (error)=>{
          console.log(error);
      });
    }
   
    admin_settings(){
      let userId: any=localStorage.getItem('userId');
      let access_token: any=localStorage.getItem('access_token');
      let api_req:any = '{"operation":"agents", "moduleType":"agents", "api_type":"web", "access_token":"'+access_token+'", "element_data":{"action":"get_admin_settings","user_id":"'+userId+'"}}';
    
      this.serverService.sendServer(api_req).subscribe((response:any) => {
        if(response.result.status==true){
          this.admins= response.result.data;
        } else {
          this.recordNotFound = true;
        }
      }, 
      (error)=>{
          console.log(error);
      });
    }

  // $("#update_admin_password").keydown(function (e) {
  
  //   if(e.which == 32){
  //           iziToast.warning({
  //             message: "Sorry, Whitespace not allowed",
  //             position: 'topRight'
  //         }); 
  //         return false;
  //   }
  //   return e.which !== 32;
  // });
  addadmin(){
    $("#initial").css("display", "block");
    $("#domain_name_card").css("display", "none");
    $("#informations").css("display", "none");
    $("#selectpermissions").css("display", "none");
    $("#progress").css("display", "none");
    $("#finish").css("display", "none");
   
    $("#add_adminform").modal('show');
   
   
  }
  getalladmins(){
    let access_token: any=localStorage.getItem('access_token');
    let api_req:any = '{"operation":"agents", "moduleType":"agents", "api_type":"web", "access_token":"'+access_token+'", "element_data":{"action":"getalladmins"}}';
    console.log(this.reseller_value);
    if( this.reseller_value!= '' ||this.reseller_value!=null){
                    
      this.reseller_sets= true;
    }
    else
    {
      this.reseller_sets= false;

    }
    this.serverService.sendServer(api_req).subscribe((response:any) => {
      if(response.status==true){  
        this.adminlists= response.result.data;
        console.log(this.adminlists);
      } 
      // else {
      //   this.recordNotFound = true;
      // }
    }, 
    (error)=>{
        console.log(error);
    }); 

  }

  manageProgress() {

   
    if(this.progress1 === 100) {
      //this.progress1 = 0;
     // this.progstatus="      Success";
      $(".progressend").prop("disabled",false);
    } else {
      this.progress1 = this.progress1 + incr;
    }
  }

  admincheck(value){
   this.radio=value;
    if (value==2)
    {  
      $("#domain_next").prop("disabled",false);
      this.showDomainNameFunc();
    }
    else if(value==1){
      $("#domain_next").prop("disabled",true);
    }

  }

  initialback(){
    $("#initial").css("display", "block");
    $("#domain_name_card").css("display", "none");
    $("#informations").css("display", "none");
    $("#progress").css("display", "none");
    $("#domainprogress").css("display", "none");
  }
  informationback(){
    $("#informations").css("display", "block");
    $("#selectpermissions").css("display", "none");
    $("#progress").css("display", "none");
    $("#domainprogress").css("display", "none");
  }
  domainoromni(){
    
    var adminordomain = this.radio;
    
    if(adminordomain==2){
      $("#initial").css("display", "none");
      $("#progress").css("display", "none");
      this.informations();
     
    }else if(adminordomain==1){
      $("#initial").css("display", "none");
      $("#progress").css("display", "none");
      $("#domain_name_card").css("display", "block");
      
    }
    
  }
  domainprogress(){
    setInterval(() => this.manageProgress(), 30 );

    $("#domain_name_card").css("display", "none");
    $("#progress").css("display", "none");
    $("#domainprogress").css("display", "block");
  }

  informations(){
    $("#domain_name_card").css("display", "none");
    $("#domainprogress").css("display", "none");
    $("#progress").css("display", "none");
    $("#informations").css("display", "block");
  }
  selectpermissions(){

    var a_name = this.addAadmin.value.admin_name;

    if((a_name!='') && (a_name != null)){
      var c_name = this.addAadmin.value.company_name;
      if((c_name!='') && (c_name != null)){
        var u_name = this.addAadmin.value.user_name;
        if((u_name!='') && (u_name != null)){
          var u_pass = this.addAadmin.value.add_admin_password;
        if((u_pass!='') && (u_pass != null)){
          $("#informations").css("display", "none");
          $("#progress").css("display", "none");
          $("#selectpermissions").css("display", "block");
        }else{
          iziToast.warning({
            message: "User Password can't be empty ",
            position: 'topRight'
        }); 
        }
        }else{
          iziToast.warning({
            message: "User Name can't be empty ",
            position: 'topRight'
        }); 
        }
        
      }else{
        iziToast.warning({
          message: "Company Name can't be empty ",
          position: 'topRight'
      }); 
      }
     
    }else{
      iziToast.warning({
        message: "Admin Name can't be empty ",
        position: 'topRight'
    }); 
    }
    

  }
  progress(companyname){
   //this.comp_name = companyname;
   this.furl = "/"+this.comp_name;
    $("#selectpermissions").css("display", "none");
    $("#progress").css("display", "block");

    let access_token: any=localStorage.getItem('access_token');
    let api_requ:any = '{"operation":"agents", "moduleType": "agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"omnichannel_create","company_name":"'+companyname+'"}}';


    this.serverService.sendServer(api_requ).subscribe((response:any) => {
      console.log(response.result.data);
      if(response.result.data.status == 1){      
         $("#progbtn").prop("disabled",false);
        
      } 
    });
    
    $('#edit_adminform').modal('hide');

  }
  finish(){
    $("#selectpermissions").css("display", "none");
    $("#progress").css("display", "none");
    $("#finish").css("display", "block");
  }
  exitprocess(){
    $("#add_adminform").modal('hide');
  }
  disablesso(isChecked: boolean){
    if(!isChecked){
      $("#a_has_teams").prop('checked',false);
      $("#a_has_sso").prop('checked',false);
    }
  }
  enablesso(isChecked: boolean){
    if(isChecked) {
     
      $("#a_has_teams").prop('checked',true);
      $("#a_has_sso").prop('checked',true);
      $("#a_voice_3cx").prop('checked',true);
      if($("#a_voice_3cx").prop('checked',true)){
        this.getCallTariffsList();
      }
      $("#a_has_contact").prop('checked',true);
      $("#a_has_chat").prop('checked',true);

      $("#has_teams").prop('checked',true);
      $("#has_sso").prop('checked',true);
      $("#e_voice_3cx").prop('checked',true);
      if($("#e_voice_3cx").prop('checked',true)){
        this.getCallTariffsList();
      }
      $("#e_has_contact").prop('checked',true);
      $("#e_has_chat").prop('checked',true);
    }else{
      
      $("#a_has_teams").prop('checked',false);
      $("#a_has_sso").prop('checked',false);

      $("#has_teams").prop('checked',false);
      $("#has_sso").prop('checked',false);
    }
  }
  getmrvoiplicense(company_name){
    let access_token: any=localStorage.getItem('access_token');
      let api_req:any = '{"operation":"agents", "moduleType": "agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"get_admin_mrvoip_license","company_name":"'+company_name+'"}}';
console.log(api_req);
this.serverService.sendServer(api_req).subscribe((response:any) => {
    this.flicense = response.result.data; 
});
    
  }
  
  editAdmindata(id,admin_id,automation){

    console.log(automation);

    this.automation_value = automation;
    console.log(this.automation_value)

    this.id=id;
    this.admin=admin_id;
    $('#checkreadinst').click();
      // console.log(admin_id);return false;
     // alert(admin_id);
    $('#edit_agents_key').val(admin_id);
    let access_token: any=localStorage.getItem('access_token');
    let api_req:any = '{"operation":"agents", "moduleType": "agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"get_single_admin_settings","pbx_id":"'+id+'"}}';
    

    this.serverService.sendServer(api_req).subscribe((response:any) => {
      if(response.result.status==true){
        var agent_data = response.result.data.admin_data;
        this.check_data = response.result.data.admin_data.select_all;
        this.days = response.result.data.admin_data.days;
        this.company_name = response.result.data.admin_data.company_name;
        console.log(this.check_data);
        this.get_dates();
        if(response.result.data.admin_data.select_all=='1' || response.result.data.admin_data.select_all==1){
          this.show_all_sel=true;
        }else{
          this.show_all_sel=false;
        }
        var show_lic = response.result.data.admin_data.mrvoip_license;
        if(show_lic != null && show_lic !='' && show_lic !=undefined){
          this.solicense = true;
        }
        var inst_data  = response.result.data.instance_data;
        if(agent_data.whatsapp_num == null){
        var nullcheck=  "";
        }else{
          nullcheck=agent_data.whatsapp_num;
        }

        this.getallwpinsts(admin_id);   
        this.editAdmin.setValue({
      
           'admin_name' : agent_data.name,
           'mrvoip_license' : agent_data.mrvoip_license,
           'user_id' : agent_data.admin_id,
           'pbx_count' : agent_data.pbx_count,
           'agent_count' : agent_data.agent_counts,
           'restrict_admin' : agent_data.limit_admin_count,
           'company_name' :agent_data.company_name,
           'domain_name' : agent_data.domain_name,
           'voice_3cx' : agent_data.voice_3cx,
           'has_contact' : agent_data.has_contact,
           'survey_vid': agent_data.survey_vid,
           'predective_dialer' : agent_data.predective_dialer,
           'lead' : agent_data.lead,
           'has_sms' : agent_data.has_sms,
           'has_mrvoipconnection' : agent_data.mr_voip,
           'has_chat' : agent_data.has_chat,
           'has_whatsapp' : agent_data.has_whatsapp,
           'has_chatbot' : agent_data.has_chatbot,
           'has_fb' : agent_data.has_fb,
           'has_fax' : agent_data.has_fb,
           'has_wechat' : agent_data.has_wechat,
           'has_telegram' : agent_data.has_telegram,
           'has_internal_ticket' : agent_data.has_internal_ticket,
           'has_external_ticket' : agent_data.has_external_ticket,
           'has_internal_chat':agent_data.has_internal_chat,
           'baisc_wallboard' : agent_data.baisc_wallboard,
           'wallboard_one' : agent_data.wallboard_one,
        'wallboard_two' : agent_data.wallboard_two,
        'wallboard_three' : agent_data.wallboard_three,
        'wallboard_four' : agent_data.wallboard_four,
        'wallboard_five' : agent_data.wallboard_five,
        'wallboard_six' : agent_data.wallboard_six,
        'wallboard_eight' : agent_data.wallboard_eight,
        'wallboard_nine' : agent_data.wallboard_nine,
        'wallboard_ten' : agent_data.wallboard_ten,
        'two_factor': agent_data.two_factor,
        'admin_status' : agent_data.admin_status,
        'whatsapp_num' : nullcheck,
        'notes':agent_data.notes,
        'a_has_sms_postpaid_upd':agent_data.sms_type,
         'has_webinar' : agent_data.has_webinar,     
         'has_rec_manage' : agent_data.voice_manage,     
         'has_queue' : agent_data.queue,     
        'has_sso' : agent_data.has_sso,    
        'has_teams' : agent_data.has_teams,
        'zoho_phone' : agent_data.has_zoho_phonebridge,
        'has_survey' : agent_data.servey_per,

        'cli_creation' : agent_data.cli_status,
        'line_token' : agent_data.line_access_token,
       });
      //  alert(agent_data.queue);
      this.line_Access_token = agent_data.line_access_token;
this.sms_price_edit=agent_data.price_sms;
this.wp_type_edit=agent_data.whatsapp_type;

this.admin_user_name = agent_data.user_name;
this.password = agent_data.password;
// this.faxuser= agent_data.fax_user_id;

$('#eMPlanName').val(agent_data.call_plan);
$('#ecall_rate').val(agent_data.call_rate);
$('#ecall_prefix').val(agent_data.call_prefix);
$('#evalid_from').val(agent_data.valid_from);
$('#evalid_to').val(agent_data.valid_to);
$('#e_tax_name').val(agent_data.tax_name);
$('#e_tax_per').val(agent_data.tax_per);
$('#upd_post_url').val(agent_data.post_url);



if(agent_data.fax_user_id != null)
{
  this.faxuser = true;
}
else{
  this.faxuser = false;

}
if(agent_data.reports == null){
  this.reportChecked = agent_data.reports;
}
else{
  this.reportChecked = agent_data.reports.split(",");
}
$('#edit_reports').val(this.reportChecked);

this.reportsvalue = this.reportChecked;
if(agent_data.mrvoip_apis == null || agent_data.mrvoip_apis == ''){
  this.mrvoip_apisChecked = [];
}
else{
  this.mrvoip_apisChecked = agent_data.mrvoip_apis.split(",");
}
this.mrvoip_v = this.mrvoip_apisChecked;
console.log(this.mrvoip_v)
$('#edit_reports').val(this.reportChecked);
if(agent_data.paid_apis==null || agent_data.paid_apis == ''){
  this.api_paid = [];
}else{
  this.api_paid = agent_data.paid_apis.split(',');
}
this.mrvoip_paid = this.api_paid;
if(agent_data.reseller == null || agent_data.reseller==''){
  this.resellerChecked = agent_data.reseller;
}
else{
  this.resellerChecked = agent_data.reseller.split(",");
}
// alert(this.wp_type_edit);
// $('.selDiv option:'+this.wp_type_edit+'').attr('selected', 'selected')
$('#inst_type_upd option[value="'+this.wp_type_edit+'"]').attr("selected", "selected");


      $('#edit_reseller').val(this.resellerChecked);

       if(agent_data.voice_3cx == 1){
        this.showCallTariffsDetEdit = true;
        $('#e_voice_3cx').prop('checked', true);
       } else {
        this.showCallTariffsDetEdit = false;
        $('#e_voice_3cx').prop('checked', false);
       }
     
       if(agent_data.predective_dialer == 1){
        $('#e_predective_dialer').prop('checked', true);
       } else {
        $('#e_predective_dialer').prop('checked', false);
       }
       if(agent_data.lead == 1){
        $('#lead').prop('checked', true);
       } else {
        $('#lead').prop('checked', false);
       }
       if(agent_data.mr_voip == 1){
        $('#has_mrvoipconnection').prop('checked', true);
       } else {
        $('#has_mrvoipconnection').prop('checked', false);
       }
       if(agent_data.servey_per == 1){
        $('#upd_has_survey').prop('checked', true);
       } else {
        $('#upd_has_survey').prop('checked', false);
       }

      //  if(agent_data.has_contact == 1){
      //   $('#e_contact').prop('checked', true);
      //  } else {
      //   $('#e_contact').prop('checked', false);
      //  }
       if(agent_data.has_contact == 1){
        $('#e_has_contact').prop('checked', true);
       } else {
        $('#e_has_contact').prop('checked', false);
       }
                    if($('#e_has_sms').prop('checked', false)){
                    this.price_sms_postpaid =true;
                    this.price_sms_upd=false;
                    } 
       if(agent_data.has_sms == 1){
        $('#e_has_sms').prop('checked', true);
        this.price_sms_upd = true;
        $('#price_sms_u').val(this.sms_price_edit);
        console.log(agent_data.price_sms);
                    
                      if(agent_data.sms_type == 1){
                        $('#a_has_sms_postpaid_upd').prop('checked', true);
                        this.price_sms_postpaid =true;

                      } else {
                       this.price_sms_postpaid =false;
                        $('#price_sms_u').val(this.sms_price_edit);
                        $('#a_has_sms_postpaid_upd').prop('checked', false);
                      }

       } else {
        this.price_sms_postpaid =true;
        this.price_sms_upd=false;
        $('#e_has_sms').prop('checked', false);
        $('#a_has_sms_postpaid_upd').prop('checked', false);
       }

       if(agent_data.has_whatsapp == 1){
        $('#e_has_whatsapp').prop('checked', true);
        this.inst_wp_upd = true;
       
        if( this.inst_wp_upd_unoff == true ){

          this.wp_inst_edit=agent_data.wp_instance_count.split(",");
          this.wp_count=this.wp_inst_edit;
        
        
        }
        else{
            this.inst_wp_upd_unoff = false;
            this.wp_inst_edit='';
            
        }
       
        $('#inst_type_upd option[value="'+this.wp_type_edit+'"]').attr("selected", "selected");
        this.onChangeupd(this.wp_type_edit);
       } 
       else {
         this.inst_wp_upd_unoff=false;
        this.inst_wp_upd = false;

        $('#e_has_whatsapp').prop('checked', false);
       }

      //  $("#inst_type_upd select").val("{agent_data.whatsapp_type}").change();
      // var target = $('#inst_type_a option:selected').val();

      //  $("#inst_type_upd > select > option[value=" + target + "]").prop("selected",true);

// console.log(agent_data.whatsapp_type);
        if(agent_data.has_chat == 1){
        $('#e_has_chat').prop('checked', true);
       } else {
        $('#e_has_chat').prop('checked', false);
       }
        if(agent_data.has_insta == 1){
        $('#has_instagram').prop('checked', true);
       } else {
        $('#has_instagram').prop('checked', false);
       }

       if(agent_data.has_chatbot == 1){
        $('#e_has_chatbot').prop('checked', true);
       } else {
        $('#e_has_chatbot').prop('checked', false);
       }

     

       if(agent_data.has_fb == 1){
        $('#e_has_fb').prop('checked', true);
       } else {
        $('#e_has_fb').prop('checked', false);
       }


       if(agent_data.has_fax == 1){
        $('#e_has_fax').prop('checked', true);
        this.line_access = true;
       } else {
        $('#e_has_fax').prop('checked', false);
       }


       if(agent_data.has_wechat == 1){
        $('#e_has_wechat').prop('checked', true);
       } else {
        $('#e_has_wechat').prop('checked', false);
       }
       if(agent_data.has_telegram == 1){
        $('#e_has_telegram').prop('checked', true);
       } else {
        $('#e_has_telegram').prop('checked', false);
       }
       
        if(agent_data.has_webinar == 1){
        $('#e_has_webinar').prop('checked', true);
       } else {
        $('#e_has_webinar').prop('checked', false);
       }

       if(agent_data.voice_manage == 1){
        $('#has_rec_manage').prop('checked', true);
       } else {
        $('#has_rec_manage').prop('checked', false);
       }
       if(agent_data.queue == 1){
        $('#has_queue').prop('checked', true);
       } else {
        $('#has_queue').prop('checked', false);
       }
       
       if(agent_data.has_internal_ticket == 1){
        $('#e_has_internal_ticket').prop('checked', true);
       } else {
        $('#e_has_internal_ticket').prop('checked', false);
       }
       if(agent_data.has_external_ticket == 1){
        $('#e_has_external_ticket').prop('checked', true);
       } else {
        $('#e_has_external_ticket').prop('checked', false);
       }

       if(agent_data.has_internal_chat == 1){
        $('#has_internal_chat').prop('checked', true);
       } else {
        $('#has_internal_chat').prop('checked', false);
       }

       $('#MPlanName').val(agent_data.tarrif_id);
       $("#MPlanName option:contains("+ $.trim( agent_data.tarrif_id ) + ")").prop('selected',true);

       if(agent_data.baisc_wallboard == 1){
        $('#baisc_wallboard').prop('checked', true);
       } else {
        $('#baisc_wallboard').prop('checked', false);
       }

       if(agent_data.wallboard_one == 1){
        $('#e_wallboard_one').prop('checked', true);
       } else {
        $('#e_wallboard_one').prop('checked', false);
       }
       if(agent_data.wallboard_two == 1){
        $('#e_wallboard_two').prop('checked', true);
       } else {
        $('#e_wallboard_two').prop('checked', false);
       }
       if(agent_data.wallboard_three == 1){
        $('#e_wallboard_three').prop('checked', true);
       } else {
        $('#e_wallboard_three').prop('checked', false);
       }
       if(agent_data.wallboard_four == 1){
        $('#e_wallboard_four').prop('checked', true);
       } else {
        $('#e_wallboard_four').prop('checked', false);
       }
      if(agent_data.wallboard_five == 1){
              $('#wallboard_five').prop('checked', true);
            } else {
              $('#wallboard_five').prop('checked', false);
            }
            
        if(agent_data.wallboard_six == 1){
              $('#wallboard_six').prop('checked', true);
            } else {
              $('#wallboard_six').prop('checked', false);
            }
  if(agent_data.wallboard_eight == 1){
              $('#wallboard_eight').prop('checked', true);
            } else {
              $('#wallboard_eight').prop('checked', false);
            }
        if(agent_data.wallboard_nine == 1){
              $('#wallboard_nine').prop('checked', true);
            } else {
              $('#wallboard_nine').prop('checked', false);
            }
        if(agent_data.wallboard_ten == 1){
              $('#wallboard_ten').prop('checked', true);
            } else {
              $('#wallboard_ten').prop('checked', false);
            }
            
            
            if(agent_data.has_sso == 1){
              $('#has_sso').prop('checked', true);
            } else {
              $('#has_sso').prop('checked', false);
            }
       if(agent_data.two_factor == 1){
        $('#e_two_factor').prop('checked', true);
       } else {
        $('#e_two_factor').prop('checked', false);
       }
       if(agent_data.has_zoho_phonebridge == 1){
        $('#e_zoho_phone').prop('checked', true);
       } else {
        $('#e_zoho_phone').prop('checked', false);
       }
       if(agent_data.cli_status == 1){
        $('#e_cli_creation').prop('checked', true);
       } else {
        $('#e_cli_creation').prop('checked', false);
       }
       if(agent_data.power_bi == 1){
        $('#power_bi').prop('checked', true);
       } else {
        $('#power_bi').prop('checked', false);
       }
       if(agent_data.has_people == 1){
        $('#has_people').prop('checked', true);
       } else {
        $('#has_people').prop('checked', false);
       }
       if(agent_data.has_webclient == 1){
        $('#has_webclient').prop('checked', true);
       } else {
        $('#has_webclient').prop('checked', false);
       }
       if(agent_data.has_billing == 1){
        $('#has_billing').prop('checked', true);
       } else {
        $('#has_billing').prop('checked', false);
       }
       if(agent_data.h_fax == 1){
        $('#h_fax').prop('checked', true);
       } else {
        $('#h_fax').prop('checked', false);
       }
       if(agent_data.admin_status == 1){
        $('#admin_status').prop('checked', true);
       } else {
        $('#admin_status').prop('checked', false);
       }

       if(agent_data.has_teams == 1){
        $('#upd_has_teams').prop('checked', true);
       } else {
        $('#upd_has_teams').prop('checked', false);
       }
       this.admin_id = agent_data.id;
       $('#edit_adminform').modal('show');
      }   
      else{
              
        iziToast.warning({
            message: "Admin data could not retrive. Please try again",
            position: 'topRight'
        });
    
  }
    }, 
    (error)=>{
        console.log(error);
    });

}


checkTotalAgent(){

  setTimeout(() => {
    
    // console.log(this.editAdmin.value.restrict_admin);
    // console.log(this.editAdmin.value.agent_count);
    console.log(this.editAdmin.value.restrict_admin > this.editAdmin.value.agent_count);
    let sum :number = this.editAdmin.value.restrict_admin;
    let num :number = this.editAdmin.value.agent_count;
    let num1 = $("#restrict_admin").val();
    let total = $("#agent_count").val();
    console.log(num1)
    console.log(total)
    // if(num1 >= total){
    //   this.show_admin_error = true;
    // }else{
    //   this.show_admin_error = false;
    // }
    
  }, 500);
  
}


dataapiEdit(id){
  let agent_req:any = this.editAdmin.value;
  var user_name = $("#admin_user_name_api").val();
  var pass = $("#update_admin_password_api").val();
let api_req:any = '{"operation":"mrvoip_apis", "moduleType":"mrvoip_apis", "api_type": "web","access_token":"'+localStorage.getItem('access_token')+'", "element_data":{"action":"update_apis_from_omni","id":"'+id+'","mrvoip_apis":"'+this.mrvoip_v+'","paid_apis":"'+this.mrvoip_paid+'","select_all":"'+this.selall+'","admin_name":"'+agent_req.admin_name+'","company_name":"'+agent_req.company_name+'","user_name":"'+user_name+'","password":"'+pass+'","domain_name":"'+agent_req.domain_name+'"}}';
console.log(api_req);
//return false;
// let api_req:any = '{"operation":"power_bi", "moduleType":"power_bi", "api_type": "web", "element_data":{"action":"update_apis","id":"'+id+'","mrvoip_apis":"'+this.mrvoip_v+'","paid_apis":"'+this.mrvoip_paid+'","select_all":"'+this.show_all_sel+'"}}';
// this.serverService.sendServer(api_req).subscribe((response:any)=>{
this.serverService.welcomeEmailMrvoip(api_req,agent_req.company_name).subscribe((response:any)=>{
if(response.result.status==true){
  if(response.result.data.user_update==1){
    let api_req_omni:any = '{"operation":"mrvoip_apis", "moduleType":"mrvoip_apis", "api_type": "web","access_token":"'+localStorage.getItem('access_token')+'", "element_data":{"action":"update_apis_from_omni","id":"'+id+'","mrvoip_apis":"'+this.mrvoip_v+'","paid_apis":"'+this.mrvoip_paid+'","select_all":"'+this.selall+'","admin_name":"'+agent_req.admin_name+'","company_name":"'+agent_req.company_name+'","user_name":"'+user_name+'","password":"'+pass+'","domain_name":"'+agent_req.domain_name+'"}}';
    this.serverService.sendServer(api_req_omni).subscribe((response:any)=>{
      if(response.result.data==1){
        iziToast.success({
          message: "User Details Updated Successfully",
          position: 'topRight'
      });
      }else{
        iziToast.error({
          message: "User Details not updated. Please try again",
          position: 'topRight'
      });
      }
    })
  }
  if(response.result.data.mrvoip_update==200){
    let api_req_omni:any = '{"operation":"mrvoip_apis", "moduleType":"mrvoip_apis", "api_type": "web","access_token":"'+localStorage.getItem('access_token')+'", "element_data":{"action":"update_apis_from_omni","id":"'+id+'","mrvoip_apis":"'+this.mrvoip_v+'","paid_apis":"'+this.mrvoip_paid+'","select_all":"'+this.selall+'","admin_name":"'+agent_req.admin_name+'","company_name":"'+agent_req.company_name+'","user_name":"'+user_name+'","password":"'+pass+'","domain_name":"'+agent_req.domain_name+'"}}';
    this.serverService.sendServer(api_req_omni).subscribe((response:any)=>{
if(response.result.data==1){
  iziToast.success({
    message: "User Details & Mr.VoIP API Updated Successfully",
    position: 'topRight'
});
}else{
  iziToast.error({
    message: "MrVoIP API not updated. Please try again",
    position: 'topRight'
});
}
    })
    
  }else{
    //pbx not install 
    iziToast.error({
      message: "MrVoIP API not updated. Please try again",
      position: 'topRight'
  });
  }
  console.log(response)
  this.admin_settings();
  $('#edit_adminform').modal('hide');
}
})

}
  dataAdminEdit(main_id){    
    
    var ad_pass=$('#update_admin_password').val();

    let agent_req:any = this.editAdmin.value;
    let access_token: any=localStorage.getItem('access_token');
    // var reports = $('#edit_reports').val().join();
    var reports = this.reportsvalue.join();
    var get_user_type : any=localStorage.getItem('user_type');
    if((this.reseller_value != '' ||this.reseller_value !=null)&&  get_user_type == "Super Admin"){
      var reseller = $('#edit_reseller').val().join();  
    }else{
        reseller = "";
      }
     //  add in API "reseller":"'+reseller+'"
    if(this.inst_wp_upd_unoff == true && $('#e_has_whatsapp').prop('checked')){
   
        var wpinst_upd = this.wp_count;
  }
   else{ 
    this.inst_wp_upd_unoff == false;
      wpinst_upd = '';
   }

    //console.log(wpinst_upd);
    // return false;
    var user_name = $('#admin_user_name').val();
    var password = $('#update_admin_password').val();
    var voice_3cx = '0';  if($('#e_voice_3cx').prop('checked')){ voice_3cx = '1'; }
    var predective_dialer = '0';  if($('#e_predective_dialer').prop('checked')){ predective_dialer = '1'; }
    var lead = '0';  if($('#lead').prop('checked')){ lead = '1'; }
    var mrvoip = '0';  if($('#has_mrvoipconnection').prop('checked')){ mrvoip = '1'; }
    var e_contact = '0';  if($('#e_has_contact').prop('checked')){ e_contact = '1'; }
    var has_sms = '0';  if($('#e_has_sms').prop('checked')){ has_sms = '1'; }
    var postpaid = '0';  if($('#a_has_sms_postpaid_upd').prop('checked')){ postpaid = '1'; }
    var has_chat = '0';  if($('#e_has_chat').prop('checked')){ has_chat = '1'; }
    var has_internal_chat = '0';  if($('#has_internal_chat').prop('checked')){ has_internal_chat = '1'; }
    var has_whatsapp = '0';  if($('#e_has_whatsapp').prop('checked')){ has_whatsapp = '1'; }
    var has_chatbot = '0';  if($('#e_has_chatbot').prop('checked')){ has_chatbot = '1'; }
    var has_fb = '0';  if($('#e_has_fb').prop('checked')){ has_fb = '1'; }
    var has_fax = '0';  if($('#e_has_fax').prop('checked')){ has_fax = '1'; }
    var has_wechat = '0';  if($('#e_has_wechat').prop('checked')){ has_wechat = '1'; }
    var has_telegram = '0';  if($('#e_has_telegram').prop('checked')){ has_telegram = '1'; }
    var has_internal_ticket = '0';  if($('#e_has_internal_ticket').prop('checked')){ has_internal_ticket = '1'; }
    var  has_external_ticket = '0';  if($('#e_has_external_ticket').prop('checked')){ has_external_ticket = '1'; }
    var  baisc_wallboard = '0';  if($('#baisc_wallboard').prop('checked')){ baisc_wallboard = '1'; }
    var  wallboard_one = '0';  if($('#e_wallboard_one').prop('checked')){ wallboard_one = '1'; }
    var  wallboard_two = '0';  if($('#e_wallboard_two').prop('checked')){ wallboard_two = '1'; }
    var  wallboard_three = '0';  if($('#e_wallboard_three').prop('checked')){ wallboard_three = '1'; }
    var  wallboard_four = '0';  if($('#e_wallboard_four').prop('checked')){ wallboard_four = '1'; }
    var  wallboard_five = '0';  if($('#wallboard_five').prop('checked')){ wallboard_five = '1'; }
    var  wallboard_six = '0';  if($('#wallboard_six').prop('checked')){ wallboard_six = '1'; }
    var  wallboard_eight = '0';  if($('#wallboard_eight').prop('checked')){ wallboard_eight = '1'; }
    var  wallboard_nine = '0';  if($('#wallboard_nine').prop('checked')){ wallboard_nine = '1'; }
    var  wallboard_ten = '0';  if($('#wallboard_ten').prop('checked')){ wallboard_ten = '1'; }
   var  has_sso = '0';  if($('#has_sso').prop('checked')){ has_sso = '1'; }
   var  zoho_phone = '0';  if($('#e_zoho_phone').prop('checked')){ zoho_phone = '1'; }
   var  has_survey = '0';  if($('#upd_has_survey').prop('checked')){ has_survey = '1'; }
    var  two_factor = '0';  if($('#e_two_factor').prop('checked')){ two_factor = '1'; }
    var admin_status = '0';  if($('#admin_status').prop('checked')){ admin_status = '1'; }
    var has_webinar = '0';  if($('#e_has_webinar').prop('checked')){ has_webinar = '1'; }
    var has_rec_manage = '0';  if($('#has_rec_manage').prop('checked')){ has_rec_manage = '1'; }
    var has_queue = '0';  if($('#has_queue').prop('checked')){ has_queue = '1'; }
    var  has_teams = '0';  if($('#upd_has_teams').prop('checked')){ has_teams = '1'; }
    var  power_bi = '0';  if($('#power_bi').prop('checked')){ power_bi = '1'; }
    var  has_people = '0';  if($('#has_people').prop('checked')){ has_people = '1'; }
    var  has_webclient = '0';  if($('#has_webclient').prop('checked')){ has_webclient = '1'; }
    var  has_billing = '0';  if($('#has_billing').prop('checked')){ has_billing = '1'; }
    var  has_instagram = '0';  if($('#has_instagram').prop('checked')){ has_instagram = '1'; }

    var  cli_status = '0';  if($('#e_cli_creation').prop('checked')){ cli_status = '1'; }
    var  h_fax = '0';  if($('#h_fax').prop('checked')){ h_fax = '1'; }

    var price_sms_upd = $('#price_sms_u').val();
    var MPlanName = $('#MPlanName').val();

   let plan_id=$('#eMPlanName').val();
   let call_rate=$('#ecall_rate').val();
   let call_prefix=$('#ecall_prefix').val();
   let valid_from=$('#evalid_from').val();
   let valid_to=$('#evalid_to').val();
   let tax_name=$('#e_tax_name').val();
   let tax_per=$('#e_tax_per').val();
   let upd_post_url=$('#upd_post_url').val();

  
  if(has_whatsapp=='1')
    var wp_type_u = $('#inst_type_upd').val();
    else
      wp_type_u = "";

      if( user_name.indexOf(" ") !== -1 )
      {
        iziToast.warning({
          message: "Username should not contain Whitespace.",
          position: 'topRight'
      });return false;
    }
      
      if( ad_pass.indexOf(" ") !== -1 )
      {
        iziToast.warning({
          message: "Password should not contain Whitespace.",
          position: 'topRight'
      }); return false;
      }
      var h_sso_auto;
     // alert(postpaid);
     if(has_teams=='1'){
      h_sso_auto = 1;
     }else{
      h_sso_auto = 0;
     }


    let api_req:any = '{"operation":"agents", "moduleType": "agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"edit_single_adminsettings","admin_name":"'+agent_req.admin_name+'","company_name":"'+agent_req.company_name+'","reseller":"'+reseller+'","domain_name":"'+agent_req.domain_name+'","whatsapp_num":"'+agent_req.whatsapp_num+'","tarrif_id":"'+MPlanName+'","survey_vid":"'+agent_req.survey_vid+'","pbx_count":"'+agent_req.pbx_count+'","limit_admin_rights":"'+agent_req.restrict_admin+'","price_sms":"'+price_sms_upd+'","user_name":"'+user_name+'","password":"'+password+'","agent_count":"'+agent_req.agent_count+'","sip_password":"'+agent_req.sip_password+'","reports":"'+reports+'","id":"'+main_id+'","voice_3cx":'+voice_3cx+',"predective_dialer":'+predective_dialer+',"lead":'+lead+',"mr_voip":'+mrvoip+',"has_contact":'+e_contact+',"has_sms":'+has_sms+',"sms_type":"'+postpaid+'","has_chat":'+has_chat+',"has_chatbot":'+has_chatbot+',"has_whatsapp":'+has_whatsapp+',"has_fb":'+has_fb+',"has_fax":'+has_fax+',"has_wechat":'+has_wechat+',"has_telegram":'+has_telegram+',"has_webinar":'+has_webinar+',"voice_manage":'+has_rec_manage+',"queue":'+has_queue+',"has_internal_ticket":'+has_internal_ticket+',"has_external_ticket":'+has_external_ticket+',"has_internal_chat":'+has_internal_chat+',"baisc_wallboard":'+baisc_wallboard+',"wallboard_one":'+wallboard_one+',"wallboard_two":'+wallboard_two+',"wallboard_three":'+wallboard_three+',"wallboard_four":'+wallboard_four+',"wallboard_five":'+wallboard_five+',"wallboard_six":'+wallboard_six+',"wallboard_eight":'+wallboard_eight+',"wallboard_nine":'+wallboard_nine+',"wallboard_ten":'+wallboard_ten+',"has_sso":'+has_sso+',"two_factor":'+two_factor+',"admin_status":'+admin_status+',"wp_instance_count":"'+wpinst_upd+'","whatsapp_type":"'+wp_type_u+'","notes":"'+agent_req.notes+'","plan_id":"'+plan_id+'","call_rate":"'+call_rate+'","valid_from":"'+valid_from+'","valid_to":"'+valid_to+'","call_prefix":"'+call_prefix+'","tax_name":"'+tax_name+'","tax_per":"'+tax_per+'","post_url":"'+upd_post_url+'","has_teams":"'+has_teams+'","has_zoho_phonebridge":"'+zoho_phone+'","power_bi":"'+power_bi+'","has_insta":"'+has_instagram+'","mrvoip_apis":"'+this.mrvoip_v+'","line_access_token":"'+this.editAdmin.value.line_token+'","has_people":"'+has_people+'","has_webclient":"'+has_webclient+'","has_billing":"'+has_billing+'","h_fax":"'+h_fax+'","servey_per":"'+has_survey+'"}}';

   

  let api_req_auto:any = '{"operation":"agents", "moduleType": "agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"edit_single_adminsettings","admin_name":"'+agent_req.admin_name+'","company_name":"'+agent_req.company_name+'","reseller":"'+reseller+'","domain_name":"'+agent_req.domain_name+'","whatsapp_num":"'+agent_req.whatsapp_num+'","tarrif_id":"'+MPlanName+'","survey_vid":"'+agent_req.survey_vid+'","pbx_count":"'+agent_req.pbx_count+'","limit_admin_rights":"'+agent_req.restrict_admin+'","price_sms":"'+price_sms_upd+'","user_name":"'+user_name+'","password":"'+password+'","agent_count":"'+agent_req.agent_count+'","sip_password":"'+agent_req.sip_password+'","reports":"'+reports+'","id":"'+main_id+'","voice_3cx":'+voice_3cx+',"predective_dialer":'+predective_dialer+',"lead":'+lead+',"mr_voip":'+mrvoip+',"has_contact":'+e_contact+',"has_sms":'+has_sms+',"sms_type":"'+postpaid+'","has_chat":'+has_chat+',"has_chatbot":'+has_chatbot+',"has_whatsapp":'+has_whatsapp+',"has_fb":'+has_fb+',"has_fax":'+has_fax+',"has_wechat":'+has_wechat+',"has_telegram":'+has_telegram+',"has_webinar":'+has_webinar+',"voice_manage":'+has_rec_manage+',"queue":'+has_queue+',"has_internal_ticket":'+has_internal_ticket+',"has_external_ticket":'+has_external_ticket+',"has_internal_chat":'+has_internal_chat+',"baisc_wallboard":'+baisc_wallboard+',"wallboard_one":'+wallboard_one+',"wallboard_two":'+wallboard_two+',"wallboard_three":'+wallboard_three+',"wallboard_four":'+wallboard_four+',"wallboard_five":'+wallboard_five+',"wallboard_six":'+wallboard_six+',"wallboard_eight":'+wallboard_eight+',"wallboard_nine":'+wallboard_nine+',"wallboard_ten":'+wallboard_ten+',"has_sso":'+h_sso_auto+',"two_factor":'+two_factor+',"admin_status":'+admin_status+',"wp_instance_count":"'+wpinst_upd+'","whatsapp_type":"'+wp_type_u+'","notes":"'+agent_req.notes+'","plan_id":"'+plan_id+'","call_rate":"'+call_rate+'","valid_from":"'+valid_from+'","valid_to":"'+valid_to+'","call_prefix":"'+call_prefix+'","tax_name":"'+tax_name+'","tax_per":"'+tax_per+'","post_url":"'+upd_post_url+'","has_teams":"'+has_teams+'","has_zohocrm":"'+zoho_phone+'","power_bi":"'+power_bi+'","mrvoip_apis":"'+this.mrvoip_v+'","line_access_token":"'+this.editAdmin.value.line_token+'","has_people":"'+has_people+'","has_webclient":"'+has_webclient+'","has_billing":"'+has_billing+'","h_fax":"'+h_fax+'","servey_per":"'+has_survey+'"}}';

  
  let api_req_mrvoip:any = '{"operation":"agents", "moduleType": "agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"edit_single_adminsettings","admin_name":"'+agent_req.admin_name+'","company_name":"'+agent_req.company_name+'","reseller":"'+reseller+'","domain_name":"'+agent_req.domain_name+'","whatsapp_num":"'+agent_req.whatsapp_num+'","tarrif_id":"'+MPlanName+'","survey_vid":"'+agent_req.survey_vid+'","pbx_count":"'+agent_req.pbx_count+'","limit_admin_rights":"'+agent_req.restrict_admin+'","price_sms":"'+price_sms_upd+'","user_name":"'+user_name+'","password":"'+password+'","agent_count":"'+agent_req.agent_count+'","sip_password":"'+agent_req.sip_password+'","reports":"'+reports+'","id":"'+main_id+'","voice_3cx":'+voice_3cx+',"predective_dialer":'+predective_dialer+',"lead":'+lead+',"mr_voip":'+mrvoip+',"has_contact":'+e_contact+',"has_sms":'+has_sms+',"sms_type":"'+postpaid+'","has_chat":'+has_chat+',"has_chatbot":'+has_chatbot+',"has_whatsapp":'+has_whatsapp+',"has_fb":'+has_fb+',"has_fax":'+has_fax+',"has_wechat":'+has_wechat+',"has_telegram":'+has_telegram+',"has_webinar":'+has_webinar+',"voice_manage":'+has_rec_manage+',"queue":'+has_queue+',"has_internal_ticket":'+has_internal_ticket+',"has_external_ticket":'+has_external_ticket+',"has_internal_chat":'+has_internal_chat+',"baisc_wallboard":'+baisc_wallboard+',"wallboard_one":'+wallboard_one+',"wallboard_two":'+wallboard_two+',"wallboard_three":'+wallboard_three+',"wallboard_four":'+wallboard_four+',"wallboard_five":'+wallboard_five+',"wallboard_six":'+wallboard_six+',"wallboard_eight":'+wallboard_eight+',"wallboard_nine":'+wallboard_nine+',"wallboard_ten":'+wallboard_ten+',"has_sso":'+has_sso+',"two_factor":'+two_factor+',"admin_status":'+admin_status+',"wp_instance_count":"'+wpinst_upd+'","whatsapp_type":"'+wp_type_u+'","notes":"'+agent_req.notes+'","plan_id":"'+plan_id+'","call_rate":"'+call_rate+'","valid_from":"'+valid_from+'","valid_to":"'+valid_to+'","call_prefix":"'+call_prefix+'","tax_name":"'+tax_name+'","tax_per":"'+tax_per+'","post_url":"'+upd_post_url+'","has_teams":"'+has_teams+'","has_zohocrm":"'+zoho_phone+'","power_bi":"'+power_bi+'","mrvoip_apis":"'+this.mrvoip_v+'","line_access_token":"'+this.editAdmin.value.line_token+'","has_people":"'+has_people+'","has_webclient":"'+has_webclient+'","has_billing":"'+has_billing+'","h_fax":"'+h_fax+'"}}';


// console.log(this.automation_value)
    if(this.automation_value == 1 || this.automation_value==3){
      this.serverService.welcomeEmailAutomation(api_req_auto,agent_req.company_name).subscribe((response: any) => {
        console.log(response);
      },
      (error) => {
           iziToast.error({
              message: "Sorry, automation is noted Updated. Please contact admin",
              position: 'topRight'
          });
          console.log(error);
      });
    }else if(this.automation_value == 2){
      this.serverService.welcomeEmailMrvoip(api_req_mrvoip,agent_req.company_name).subscribe((response: any) => {
        console.log(response);
      },
      (error) => {
           iziToast.error({
              message: "Sorry, automation is noted Updated. Please contact admin",
              position: 'topRight'
          });
          console.log(error);
      });
    }


        this.serverService.sendServer(api_req).subscribe((response: any) => {
        if (response.result.data == 1) {
          if(has_sso=='1'){
            setInterval(() => this.manageProgress(), 30 );
            this.progress(agent_req.company_name);
            this.editAdmin.reset();

          }else{
            $('#edit_adminform').modal('hide');
          }
               // $('#edit_adminform').modal('hide');
                this.editAdmin.reset();
                this.admin_settings();
              this.getwpinsts();
                iziToast.success({
                    message: "Admin data updated successfully",
                    position: 'topRight'
                });
            }
        else{
                iziToast.warning({
                    message: "Admin data  not updated. Please try again",
                    position: 'topRight'
                });
            
        }

  
    },
    (error) => {
         iziToast.error({
            message: "Sorry, some server issue occur. Please contact admin",
            position: 'topRight'
        });
        console.log(error);
    });
  }

  addadminData(e){
    e.preventDefault();
   //console.log(this.addAadmin.value);
    let agent_req:any = this.addAadmin.value;
    let access_token: any=localStorage.getItem('access_token');
    console.log($('#add_reports').val());
  if($('#add_reports').val()!='' && $('#add_reports').val()!=null){
  var reports = $('#add_reports').val().join();
  }
    

    if($('#a_notes').val()!='' && $('#a_notes').val()!=null){
      this.notes_valid = false;
    }else{
      this.notes_valid = true;
      return false;
    }
    let get_user_type : any=localStorage.getItem('user_type');
   
    if((this.reseller_value != '' || this.reseller_value !=null) &&  get_user_type == "Super Admin" ){
     
      if($('#add_reseller').val()!='' && $('#add_reseller').val()!=null){
        var reseller = $('#add_reseller').val().join(); 
      }
     
    }else{
      reseller = "";
    }
    console.log(reports);
  
    if($('#a_has_whatsapp').prop('checked')){ 
     if(this.inst_wp_upd_unoff==true){
     
        var wpinst = $('#add_mul_inst').val().join();
     }
     } 
else{
this.inst_wp_upd_unoff==false;
}
    console.log(wpinst);
    // return false;
    // var sso = '0';  if($('#sso').prop('checked')){ sso = '1';}
    // var teams = '0';  if($('#teams').prop('checked')){ teams = '1';}
    var voice_3cx = '0';  if($('#a_voice_3cx').prop('checked')){ voice_3cx = '1';}
    var predective_dialer = '0';  if($('#a_predective_dialer').prop('checked')){ predective_dialer = '1'; }
    var lead = '0';  if($('#a_lead').prop('checked')){ lead = '1'; }
    var mrvoip = '0';  if($('#a_mrvoip').prop('checked')){ mrvoip = '1'; }
    var has_contact = '0';  if($('#a_has_contact').prop('checked')){ has_contact = '1'; }
    var has_sms = '0';  if($('#a_has_sms').prop('checked')){ has_sms = '1'; }
    var postpaid = '0';  if($('#a_has_sms_postpaid').prop('checked')){ postpaid = '1'; }
    var has_chat = '0';  if($('#a_has_chat').prop('checked')){ has_chat = '1'; }
    var has_internal_chat = '0';  if($('#a_has_internal_chat').prop('checked')){ has_internal_chat = '1'; }
    var has_whatsapp = '0';  if($('#a_has_whatsapp').prop('checked')){ has_whatsapp = '1'; }
    var has_chatbot = '0';  if($('#a_has_chatbot').prop('checked')){ has_chatbot = '1'; }
    var has_fb = '0';  if($('#a_has_fb').prop('checked')){ has_fb = '1'; }
    var has_fax = '0';  if($('#a_has_fax').prop('checked')){ has_fax = '1'; }
    var has_wechat = '0';  if($('#a_has_wechat').prop('checked')){ has_wechat = '1'; }
    var has_telegram = '0';  if($('#a_has_telegram').prop('checked')){ has_telegram = '1'; }
    var has_internal_ticket = '0';  if($('#a_has_internal_ticket').prop('checked')){ has_internal_ticket = '1'; }
    var  has_external_ticket = '0';  if($('#a_has_external_ticket').prop('checked')){ has_external_ticket = '1'; }
    var  baisc_wallboard = '0';  if($('#a_baisc_wallboard').prop('checked')){ baisc_wallboard = '1'; }
    var  wallboard_one = '0';  if($('#a_wallboard_one').prop('checked')){ wallboard_one = '1'; }
    var  wallboard_two = '0';  if($('#a_wallboard_two').prop('checked')){ wallboard_two = '1'; }
    var  wallboard_three = '0';  if($('#a_wallboard_three').prop('checked')){ wallboard_three = '1'; }
    var  wallboard_four = '0';  if($('#a_wallboard_four').prop('checked')){ wallboard_four = '1'; }
    var  wallboard_five = '0';  if($('#a_wallboard_five').prop('checked')){ wallboard_five = '1'; }
    var  wallboard_six = '0';  if($('#a_wallboard_six').prop('checked')){ wallboard_six = '1'; }
    var  wallboard_eight = '0';  if($('#a_wallboard_eight').prop('checked')){ wallboard_eight = '1'; }
    var  wallboard_nine = '0';  if($('#a_wallboard_nine').prop('checked')){ wallboard_nine = '1'; }
    var  wallboard_ten = '0';  if($('#a_wallboard_ten').prop('checked')){ wallboard_ten = '1'; }
          var  has_sso = '0';  if($('#a_has_sso').prop('checked')){ has_sso = '1'; }
          var  has_teams = '0';  if($('#a_has_teams').prop('checked')){ has_teams = '1'; }
          var  zoho_phone = '0';  if($('#a_zoho_phone').prop('checked')){ zoho_phone = '1'; }
    var  two_factor = '0';  if($('#a_two_factor').prop('checked')){ two_factor = '1'; }
    var  admin_status = '0';  if($('#a_admin_status').prop('checked')){ admin_status = '1'; }
    var has_webinar = '0';  if($('#a_has_webinar').prop('checked')){ has_webinar = '1'; }
    var has_rec_manage = '0';  if($('#a_has_rec_manage').prop('checked')){ has_rec_manage = '1'; }
    var has_queue = '0';  if($('#a_has_queue').prop('checked')){ has_queue = '1'; }
    
    var price_sms_a = $('#price_sms_a').val();
    var add_pass= $('#add_admin_password').val();
    console.log(add_pass);

    var a_MPlanName = $('#a_MPlanName').val()


    var  wp_inst_count_a = $('#inst_add').val();
    var  wp_inst_type_a  = $('#inst_type_a').val();
    

if( agent_req.user_name.indexOf(" ") !== -1 )
{
iziToast.warning({
  message: "Username should not contain Whitespace.",
  position: 'topRight'
});
return false;
}
if( add_pass.indexOf(" ") !== -1 )
{
iziToast.warning({
  message: "Password should not contain Whitespace.",
  position: 'topRight'
});
return false;
}
//alert(postpaid);alert(price_sms_a);
    let plan_id=$('#add_MPlanName').val();
    let call_rate=$('#call_rate').val();
    let call_prefix=$('#call_prefix').val();
    let valid_from=$('#valid_from').val();
    let valid_to=$('#valid_to').val();
    let tax_name=$('#a_tax_name').val();
    let tax_per=$('#a_tax_per').val();
    let add_post_url=$('#add_post_url').val();
this.fusername = agent_req.user_name;
this.fpassword = add_pass;
this.comp_name = agent_req.company_name;
   let new_id : any=localStorage.getItem('admin_id'); 
    let api_req:any = '{"operation":"agents", "moduleType": "agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"add_single_admin","name":"'+agent_req.admin_name+'","user_id":"'+new_id+'","company_name":"'+agent_req.company_name+'","price_sms":"'+price_sms_a+'","wp_instance_count":"'+wpinst+'","whatsapp_type":"'+wp_inst_type_a+'","domain_name":"'+agent_req.domain_name+'","pbx_count":"'+agent_req.pbx_count+'","tarrif_id":"'+a_MPlanName+'","survey_vid":"'+agent_req.survey_vid+'","whatsapp_num":"'+agent_req.whatsapp_num+'","agent_counts":"'+agent_req.agent_count+'","reports":"'+reports+'","user_name":"'+agent_req.user_name+'","user_password":"'+add_pass+'","voice_3cx":"'+voice_3cx+'","predective_dialer":"'+predective_dialer+'","lead":"'+lead+'","mr_voip":"'+mrvoip+'","has_contact":"'+has_contact+'","has_sms":"'+has_sms+'","sms_type":"'+postpaid+'","has_chat":"'+has_chat+'","has_whatsapp":"'+has_whatsapp+'","has_fb":"'+has_fb+'","reseller":"'+reseller+'","has_fax":"'+has_fax+'","has_wechat":"'+has_wechat+'","has_telegram":"'+has_telegram+'","has_webinar":"'+has_webinar+'","voice_manage":"'+has_rec_manage+'","queue":"'+has_queue+'","has_internal_ticket":"'+has_internal_ticket+'","has_external_ticket":"'+has_external_ticket+'","has_internal_chat":"'+has_internal_chat+'","baisc_wallboard":"'+baisc_wallboard+'","wallboard_one":"'+wallboard_one+'","wallboard_two":"'+wallboard_two+'","wallboard_three":"'+wallboard_three+'","wallboard_four":"'+wallboard_four+'","wallboard_five":"'+wallboard_five+'","wallboard_six":"'+wallboard_six+'","wallboard_eight":"'+wallboard_eight+'","wallboard_nine":"'+wallboard_nine+'","wallboard_ten":"'+wallboard_ten+'","has_sso":"'+has_sso+'","has_teams":"'+has_teams+'","two_factor":"'+two_factor+'","admin_status":"'+admin_status+'","has_chatbot":"'+has_chatbot+'","notes":"'+agent_req.notes+'","plan_id":"'+plan_id+'","call_rate":"'+call_rate+'","valid_from":"'+valid_from+'","valid_to":"'+valid_to+'","call_prefix":"'+call_prefix+'","tax_name":"'+tax_name+'","tax_per":"'+tax_per+'","post_url":"'+add_post_url+'","zoho_phone":"'+zoho_phone+'"}}';
console.log(api_req);

    this.serverService.sendServer(api_req).subscribe((response:any) => {
      if(response.result.data == 1){
        
            // 
            if(has_sso=='1'){
              setInterval(() => this.manageProgress(), 30 );
              this.progress(agent_req.company_name);
              this.addAadmin.reset();

            }else{
             
              this.getmrvoiplicense(agent_req.company_name);

              this.finish();
             // $('#add_adminform').modal('hide');

            }
            this.addAadmin.reset();
            this.admin_settings();
        this.getNodelicense();

            iziToast.success({
                message: "Admin created successfully",
                position: 'topRight'
            });
            
            
            
      }  else if(response.result.data == 3){
              iziToast.warning({
                message: "Username name already in use",
                position: 'topRight'
            });
  
       }else if(response.result.data == 4){
        iziToast.warning({
          message: "Company name already in use",
          position: 'topRight'
      });

 }
        else{
              
        iziToast.warning({
            message: "Admin data could not retrive. Please try again",
            position: 'topRight'
        });
    
  }
    }, 
    (error)=>{
        console.log(error);
    });
    
  }

  actCamp(to_per,id,automation,company){
    let agent_req:any = this.addAadmin.value;
    let access_token: any=localStorage.getItem('access_token');
    let api_req:any = '{"operation":"agents", "moduleType": "agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"take_down_toggle_status","status_for":"'+to_per+'","id":"'+id+'"}}';
    this.serverService.sendServer(api_req).subscribe((response:any) => {
      if(response.result.data == 1){
        if(automation==1){
        let api_req_automation:any = '{"operation":"agents", "moduleType": "agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"take_down_toggle_status","status_for":"'+to_per+'","id":"1"}}';
        this.serverService.welcomeEmailAutomation(api_req_automation,company).subscribe((response:any)=>{
          if(response.result.data == 1){
            this.admin_settings();
          }
        })
        }
     }else{
      this.admin_settings();
     }
    }, 
    (error)=>{
        console.log(error);
    });
  }

  deletedata(id,automation,user_id,company){

    let access_token: any=localStorage.getItem('access_token');
    let u_id: any=localStorage.getItem('userId');
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        let api_req:any = '{"operation":"agents", "moduleType":"agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"delete_admin","user_id":"'+id+'"}}';
        this.serverService.sendServer(api_req).subscribe((response:any) => {
          if(response.result.data==1){
            iziToast.success({
              message: "Admin deleted successfully",
              position: 'topRight'
          });
          if(automation==1||automation==2||automation==3){
            let api_reqs:any = '{"operation":"delete", "moduleType": "delete", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"delete","user_id":"'+user_id+'","company_name":"'+company+'","automation_type":"'+automation+'"}}';
            this.serverService.sendServer(api_reqs).subscribe((respons:any)=>{
              console.log(respons);
            });
          }
          this.admin_settings();  
   this.getNodelicense();
  }
        }, 
        (error)=>{
            console.log(error);
        });
      }
    })
      
    }

    toggleClasss(event){
      $(this).toggleClass('fa-eye fa-eye-slash');
      $(event.target).toggleClass('fa-eye fa-eye-slash');
      var input = $($(event.target).attr("toggle"));

      if (input.attr("type") == "password") {
        input.attr("type", "text");
      } else {
        input.attr("type", "password");
      }
    };
    
    priceSMS(data){
      //alert(data);
      if(data == 'update'){
        if($('#e_has_sms').prop('checked') || $('#node_has_sms').prop('checked')){ 
        // $('#a_has_sms_postpaid_upd').prop('checked', false);

            if($('#a_has_sms_postpaid_upd').prop('checked') || $('#node_a_has_sms_postpaid_upd').prop('checked')){this.price_sms_postpaid= true;} else {  $('#a_has_sms_postpaid_upd').prop('checked', false); this.price_sms_postpaid = false;}
          this.price_sms_upd = true;this.price_sms_postpaid = true;
             
        } 
        else {
          this.price_sms_upd = false; this.price_sms_postpaid = true;
        }
        // if($('#a_has_sms_postpaid_upd').prop('checked')){ this.price_sms_postpaid= true;  this.price_sms_upd = true; } else { this.price_sms_postpaid = false;}

      } 
      else if(data == 'postpaid') {
        
        if($('#a_has_sms_postpaid').prop('checked') || $('#node_a_has_sms_postpaid').prop('checked')){ this.price_sms_postpaid = true;  } else {this.price_sms_add = true; this.price_sms_postpaid = false;}
      }

      else if(data == 'postpaidupd') {
        
        if($('#a_has_sms_postpaid_upd').prop('checked') || $('#node_a_has_sms_postpaid_upd').prop('checked')){ this.price_sms_postpaid= true;  this.price_sms_upd = true; } else { this.price_sms_postpaid = false; this.price_sms_upd = true;}
      }

      else {
        // alert(data);
        $('#a_has_sms_postpaid_upd').prop('checked', false);
        $('#node_a_has_sms_postpaid_upd').prop('checked', false);

        if($('#a_has_sms').prop('checked') || $('#node_a_has_sms').prop('checked')){ this.price_sms_add = true; this.price_sms_postpaid = false; } else {this.price_sms_add = false; this.price_sms_postpaid = true; }
      }
    }
    wpinst(data){
      console.log(data);
              if(data == 'update'){
                if($('#e_has_whatsapp').prop('checked') || $('#node_has_whatsapp').prop('checked')){ this.inst_wp_upd = true;} else {this.inst_wp_upd = false; this.inst_wp_upd_unoff = false;}
              } 
              else {
                if($('#a_has_whatsapp').prop('checked') || $('#node_a_has_whatsapp').prop('checked')){ this.inst_wp_add = true; } else {this.inst_wp_add_unoff = false;this.inst_wp_add = false; }
              }
      
            }
            line_per(data){
              if(data == 'update'){
                if($("#e_has_fax").prop('checked')){
                  this.line_access = true;
                }else{
                  this.line_access = false;
                }
              }
            }
            onChange(deviceValue) {
              if(deviceValue == 0){
              //  this.inst_wp_upd_unoff = true;

              if($('#a_has_whatsapp').prop('checked') || $('#node_a_has_whatsapp').prop('checked')){ this.inst_wp_add_unoff = true;} else {this.inst_wp_add_unoff = false;}
              } 
              else{
                 this.inst_wp_add_unoff = false;
              } 
              console.log(deviceValue);
          }
          onChangeupd(deviceValue) {
            console.log(deviceValue);

            if(deviceValue == 0){
               this.inst_wp_upd_unoff = true;
            } 
            else{
               this.inst_wp_upd_unoff = false;
            } 
            
        }



  showDomainNameFunc(){
    if(this.radio==1){
      this.showDomainName = true;
    }else{
      this.showDomainName = false;
    }
  }
 
  getCallTariffsList(){
    //alert(this.addAadmin.value.voice_3cx);
    // if(this.addAadmin.value.voice_3cx == null || this.addAadmin.value.voice_3cx == false||this.addNodeAadmin.value.voice_3cx == null || this.addNodeAadmin.value.voice_3cx == false){
     // alert( this.showCallTariffsDet)

      //this.showCallTariffsDet = true;
      
    // } else {
    //   this.showCallTariffsDet = false;
    // }
    
    if($("#a_voice_3cx").prop('checked')){
      this.showCallTariffsDet = true;
    }else{
      this.showCallTariffsDet = false;
    }
}
  
  getCallTariffsListe(){
    // if(this.editAdmin.value.voice_3cx == null || this.editAdmin.value.voice_3cx == false){
    //   this.showCallTariffsDetEdit = true;
    // } else {
    //   this.showCallTariffsDetEdit = false;
    // }

    if($("#e_voice_3cx").prop('checked')){
      this.showCallTariffsDetEdit = true;
    }else{
      this.showCallTariffsDetEdit = false;
    }
  }
  getcalltariffs(){
    let access_token: any=localStorage.getItem('access_token');
    let admin_id: any=localStorage.getItem('admin_id');

    let api_req:any = '{"operation":"call_tarrif", "moduleType":"call_tarrif", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"view_call_tarrif","admin_id": "'+admin_id+'"}}';
    this.serverService.sendServer(api_req).subscribe((response:any) => {
      if(response.status == true){
      this.callTariffs = response.result.data.plans;
      } else {
      }
    }, 
    (error)=>{
      console.log(error);
    });
  }
  
  edit_billing_address(){

    // $('#edit_billing_address').reset();
   
   
     var user_id = $('#edit_agents_key').val();
     //alert(user_id);
     let access_token: any=localStorage.getItem('access_token');
     let admin_id: any=localStorage.getItem('admin_id');
     let api_req:any = '{"operation":"agents", "moduleType":"agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"edit_agent_billing_det","admin_id": "1","id":"'+user_id+'"}}';
     this.serverService.sendServer(api_req).subscribe((response:any) => {
       if(response.status==true){
         if(response.result.data !=""){
          // alert(response.result.data);
           var ab = response.result.data[0]
   //alert(ab.edit_ship); 
           if(ab.edit_ship == '1'){
             $('#eedit_ship').prop('checked', true);
             $('#editShippingAddresss').attr('style','display:flex');
     
             $('#econtact_person').val(ab.contact_person);
             $('#eadd1').val(ab.add1);
             $('#eadd2').val(ab.add2);
             $('#ecity').val(ab.city);
             $('#estate').val(ab.state);
             $('#ezip_code').val(ab.zip_code);
             $('#ecountry').val(ab.country);
             $('#e_monthly_charges').val(ab.monthly_charges);
             $('#e_discount_per').val(ab.discount);
             $('#eship_contact').val(ab.ship_contact);
             $('#eship_to').val(ab.ship_to);
             $('#eship_add1').val(ab.ship_add1);
             $('#eship_add2').val(ab.ship_add2);
             $('#eship_city').val(ab.ship_city);
             $('#eship_state').val(ab.ship_state);
             $('#eship_zip').val(ab.ship_zip);
             $('#eship_country').val(ab.ship_country);
           } else {
     
             $('#econtact_person').val(ab.contact_person);
             $('#eadd1').val(ab.add1);
             $('#eadd2').val(ab.add2);
             $('#ecity').val(ab.city);
             $('#estate').val(ab.state);
             $('#ezip_code').val(ab.zip_code);
             $('#ecountry').val(ab.country);
             $('#e_monthly_charges').val(ab.monthly_charges);
             $('#e_discount_per').val(ab.discount);
           }
     
     
     
           
          
           $('#edit_agents_form').modal('hide');
           $('#edit_billing_address').modal('show');
   
         } else {
         //alert('called');


         $('#edit_agents_form').modal('hide');
         $('#edit_billing_address').modal('show');        
          
         // temp for clean a id values
           $('#econtact_person').val('');
           $('#eadd1').val('');
           $('#eadd2').val('');
           $('#ecity').val('');
           $('#estate').val('');
           $('#ezip_code').val('');
           $('#ecountry').val('');
           $('#e_monthly_charges').val('');
           $('#e_discount_per').val('');
           $('#eship_contact').val('');
           $('#eship_to').val('');
           $('#eship_add1').val('');
           $('#eship_add2').val('');
           $('#eship_city').val('');
           $('#eship_state').val('');
           $('#eship_zip').val('');
           $('#eship_country').val('');  
           $('#econtact_person').val('');
           $('#eadd1').val('');
           $('#eadd2').val('');
           $('#ecity').val('');
           $('#estate').val('');
           $('#ezip_code').val('');
           $('#ecountry').val('');
           $('#e_monthly_charges').val('');
           $('#e_discount_per').val('');
         


           $('#edit_agents_form').modal('hide');
           $('#edit_billing_address').modal('show');
         }
   
         
       } else {
        
       }
     }, 
     (error)=>{
         console.log(error);
     });
   
   
   
   }

   editShippingAddress(){
    if($( "#eedit_ship" ).is( ":checked" ) ){
     this.editShippingAddresss = true;
     $('#editShippingAddresss').attr('style','display:flex');
    } else {
     this.editShippingAddresss = false;
     $('#editShippingAddresss').attr('style','display:none');
    }
    
   }
   
   
editShippingAddressMain(){
// var user_id = $('#edit_agents_key').val();
// var contact_person =  $('#contact_person').val();
// var add1 =  $('#add1').val();
// var add2 =  $('#add2').val();
// var city =  $('#city').val();
// var state =  $('#state').val();
// var zip_code =  $('#zip_code').val();
// var country =  $('#country').val();
// var edit_ship =  $('#edit_ship').val();
// var ship_contact =  $('#ship_contact').val();
// var ship_to =  $('#ship_to').val();
// var ship_add1 =  $('#ship_add1').val();
// var ship_add2 =  $('#ship_add2').val();
// var ship_city =  $('#ship_city').val();
// var ship_state =  $('#ship_state').val();
// var ship_zip =  $('#ship_zip').val();
// var ship_country =  $('#ship_country').val();

var user_id = $('#edit_agents_key').val();
var contact_person =  $('#econtact_person').val();
var add1 =  $('#eadd1').val();
var add2 =  $('#eadd2').val();
var city =  $('#ecity').val();
var state =  $('#estate').val();
var zip_code =  $('#ezip_code').val();
var country =  $('#ecountry').val();
var ship_contact =  $('#eship_contact').val();
var ship_to =  $('#eship_to').val();
var ship_add1 =  $('#eship_add1').val();
var ship_add2 =  $('#eship_add2').val();
var ship_city =  $('#eship_city').val();
var ship_state =  $('#eship_state').val();
var ship_zip =  $('#eship_zip').val();
var ship_country =  $('#eship_country').val();
var monthly_charges =  $('#e_monthly_charges').val();
var discount_per =  $('#e_discount_per').val();


if(contact_person == "" || add1 == "" || city == "" || state == "" || zip_code == "" || country == ""){
iziToast.warning({
message: "Please Fill The Required Field",
position: 'topRight'
}); 
return false;
}

if($( "#eedit_ship" ).is( ":checked" ) ){
var edit_ship =  '1';
} else {
var edit_ship =  '0';
}

if($( "#eedit_ship" ).is( ":checked" ) ){
if(ship_contact == "" || ship_to == "" || ship_add1 == "" || ship_city == "" || ship_state == "" || ship_zip == "" || ship_country == "" ){
iziToast.warning({
message: "Please Fill The Required Field",
position: 'topRight'
}); 
return false;
}
else{
ship_contact =  contact_person;
ship_to =  contact_person;
ship_add1 =  add1;
ship_add2 =  add2;
ship_city =  city;
ship_state =  state;
ship_zip =  zip_code;
ship_country = country;
}
}
let access_token: any=localStorage.getItem('access_token');
let api_req:any = '{"operation":"agents", "moduleType":"agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"update_agent_billing_det","admin_id": "1","user_id":"'+user_id+'","contact_person":"'+contact_person+'","add1":"'+add1+'","add2":"'+add2+'","city":"'+city+'","state":"'+state+'","zip_code":"'+zip_code+'","country":"'+country+'","edit_ship":"'+edit_ship+'","ship_contact":"'+ship_contact+'","ship_to":"'+ship_to+'","ship_add1":"'+ship_add1+'","ship_add2":"'+ship_add2+'","ship_city":"'+ship_city+'","ship_state":"'+ship_state+'","ship_zip":"'+ship_zip+'","ship_country":"'+ship_country+'","monthly_charges":"'+monthly_charges+'","discount_per":"'+discount_per+'"}}';

// console.log(api_req); return false;
this.serverService.sendServer(api_req).subscribe((response:any) => {
if(response.status == true){
$('#edit_billing_address').modal('hide');
// $('#edit_billing_address').reset();
this.editShippingAddresss = false;
} else {
}
}, 
(error)=>{
console.log(error);
});

}

closeLoading(){
Swal.close();
}
genInvoice(id,email){
let access_token: any=localStorage.getItem('access_token');
let admin_id: any=localStorage.getItem('admin_id');
Swal.fire({
title: 'Please Wait',
allowEscapeKey: false,
allowOutsideClick: false,
//  background: '#19191a',
showConfirmButton: false,
onOpen: ()=>{
Swal.showLoading();
}
});

let api_req:any = '{"operation":"call_tarrif", "moduleType":"call_tarrif", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"gen_admin_invoice","user_id":"'+id+'","admin_id":"1"}}';
this.serverService.sendServer(api_req).subscribe((response:any) => {
console.log(response);
Swal.close();

if(response.status==true){

if(response.result.data == null){
iziToast.error({
message: "Sorry,some error occure",
position: 'topRight'
});
} else if(response.result.data.data == '2'){
  this.pdfurl = response.result.data.url;
  $("#showGeneratedPdf").modal('show');
}              

else if(response.result.data.data == '3'){
iziToast.error({
message: "Update user billing address",
position: 'topRight'
});
Swal.fire({
  title: 'Update user Billing Address',
  text: "click the update user icon -> Update Billing Address",
  icon: 'info',
  showCancelButton: false,
  confirmButtonColor: '#3085d6',   
  confirmButtonText: 'Got it'
})  

}
else if(response.result.data.data == '4'){
iziToast.error({
message: "Admin billing Address not available",
position: 'topRight'
});
Swal.fire({
title: 'Update Admin Billing Address',
text: "Go to profile(by clicking profile Icon)-> Update Billing Address",
icon: 'info',
showCancelButton: false,
confirmButtonColor: '#3085d6',          
confirmButtonText: 'Got it'
})

}   else if(response.result.data.data == '5'){
iziToast.error({
 message: "User does not have call plan",
position: 'topRight'
});
Swal.fire({
title: 'Voice 3CX permission',
text: "Update your user with voice3CX permission,you should provide plan details for specific user",
icon: 'info',
showCancelButton: false,
confirmButtonColor: '#3085d6',          
confirmButtonText: 'Got it'
})

}

else  {
var arrStr = encodeURIComponent(JSON.stringify(response));

// document.location.href = 'https://omni.mconnectapps.com/api/storage/contact/download.php?res='+arrStr;
var url = 'https://omni.mconnectapps.com/api/storage/invoice/invoice.php';
var form = $('<form action="' + url + '" method="post">' +
  '<input type="text" name="res" value="' + arrStr + '" />' +
  '</form>');
$('body').append(form);
form.submit();
}

}
}, 
(error)=>{
console.log(error);
});
}
addNodeadminData(){
let agent_req:any = this.addNodeAadmin.value;
let access_token: any=localStorage.getItem('access_token');
if($('#node_add_reports').val()!=''){
  var reports = $('#node_add_reports').val().join();

}

let get_user_type : any=localStorage.getItem('user_type');
if((this.reseller_value != '' ||this.reseller_value !=null) &&  get_user_type == "Super Admin" ){
if($('#node_add_reseller').val()!='' || $('#node_add_reseller').val()!=null){
  var reseller = $('#node_add_reseller').val().join(); 
}

}else{
reseller = "";
}
console.log(reports);

if($('#node_a_has_whatsapp').prop('checked')){ 
if(this.inst_wp_upd_unoff==true){

var wpinst = $('#node_add_mul_inst').val().join();
}
} 
else{
this.inst_wp_upd_unoff==false;
}
console.log(wpinst);
// return false;

var voice_3cx = '0';  if($('#node_a_voice_3cx').prop('checked')){ voice_3cx = '1';}
var predective_dialer = '0';  if($('#node_a_predective_dialer').prop('checked')){ predective_dialer = '1'; }
var lead = '0';  if($('#node_a_lead').prop('checked')){ lead = '1'; }
var mrvoip = '0';  if($('#node_a_mrvoip').prop('checked')){ mrvoip = '1'; }
var has_contact = '0';  if($('#node_a_has_contact').prop('checked')){ has_contact = '1'; }
var has_sms = '0';  if($('#node_a_has_sms').prop('checked')){ has_sms = '1'; }
var postpaid = '0';  if($('#node_a_has_sms_postpaid').prop('checked')){ postpaid = '1'; }
var has_chat = '0';  if($('#node_a_has_chat').prop('checked')){ has_chat = '1'; }
var has_internal_chat = '0';  if($('#node_a_has_internal_chat').prop('checked')){ has_internal_chat = '1'; }
var has_whatsapp = '0';  if($('#node_a_has_whatsapp').prop('checked')){ has_whatsapp = '1'; }
var has_chatbot = '0';  if($('#node_a_has_chatbot').prop('checked')){ has_chatbot = '1'; }
var has_fb = '0';  if($('#node_a_has_fb').prop('checked')){ has_fb = '1'; }
var has_fax = '0';  if($('#node_a_has_fax').prop('checked')){ has_fax = '1'; }
var has_wechat = '0';  if($('#node_a_has_wechat').prop('checked')){ has_wechat = '1'; }
var has_telegram = '0';  if($('#node_a_has_telegram').prop('checked')){ has_telegram = '1'; }
var has_internal_ticket = '0';  if($('#node_a_has_internal_ticket').prop('checked')){ has_internal_ticket = '1'; }
var  has_external_ticket = '0';  if($('#mode_a_has_external_ticket').prop('checked')){ has_external_ticket = '1'; }
var  baisc_wallboard = '0';  if($('#node_a_baisc_wallboard').prop('checked')){ baisc_wallboard = '1'; }
var  wallboard_one = '0';  if($('#node_a_wallboard_one').prop('checked')){ wallboard_one = '1'; }
var  wallboard_two = '0';  if($('#node_a_wallboard_two').prop('checked')){ wallboard_two = '1'; }
var  wallboard_three = '0';  if($('#node_a_wallboard_three').prop('checked')){ wallboard_three = '1'; }
var  wallboard_four = '0';  if($('#node_a_wallboard_four').prop('checked')){ wallboard_four = '1'; }
var  wallboard_five = '0';  if($('#node_a_wallboard_five').prop('checked')){ wallboard_five = '1'; }
var  wallboard_six = '0';  if($('#node__wallboard_six').prop('checked')){ wallboard_six = '1'; }
var  wallboard_eight = '0';  if($('#node_a_wallboard_eight').prop('checked')){ wallboard_eight = '1'; }
var  wallboard_nine = '0';  if($('#node_a_wallboard_nine').prop('checked')){ wallboard_nine = '1'; }
var  two_factor = '0';  if($('#node_a_two_factor').prop('checked')){ two_factor = '1'; }
var  admin_status = '0';  if($('#node_a_admin_status').prop('checked')){ admin_status = '1'; }
var has_webinar = '0';  if($('#node_a_has_webinar').prop('checked')){ has_webinar = '1'; }
var has_rec_manage = '0';  if($('#node_a_has_rec_manage').prop('checked')){ has_rec_manage = '1'; }
var has_queue = '0';  if($('#node_a_has_queue').prop('checked')){ has_queue = '1'; }

var price_sms_a = $('#node_price_sms_a').val();
var add_pass= $('#node_add_admin_password').val();
console.log(add_pass);

var a_MPlanName = $('#node_a_MPlanName').val()


var  wp_inst_count_a = $('#node_inst_add').val();
var  wp_inst_type_a  = $('#node_inst_type_a').val();


//alert(postpaid);alert(price_sms_a);
let plan_id=$('#node_add_MPlanName').val();
let call_rate=$('#node_call_rate').val();
let call_prefix=$('#node_call_prefix').val();
let valid_from=$('#node_valid_from').val();
let valid_to=$('#node_valid_to').val();
let tax_name=$('#node_a_tax_name').val();
let tax_per=$('#node_a_tax_per').val();
let add_post_url=$('#node_add_post_url').val();
let license_key=$('#node_license_key').val();
let new_id : any=localStorage.getItem('admin_id'); 
let api_req:any = '{"operation":"agents", "moduleType": "agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"add_nord_admin","name":"'+agent_req.admin_name+'","user_id":"'+new_id+'","price_sms":"'+price_sms_a+'","wp_instance_count":"'+wpinst+'","whatsapp_type":"'+wp_inst_type_a+'","domain_name":"'+agent_req.domain_name+'","pbx_count":"'+agent_req.pbx_count+'","tarrif_id":"'+a_MPlanName+'","survey_vid":"'+agent_req.survey_vid+'","whatsapp_num":"'+agent_req.whatsapp_num+'","agent_counts":"'+agent_req.agent_count+'","reports":"'+reports+'","voice_3cx":"'+voice_3cx+'","predective_dialer":"'+predective_dialer+'","lead":"'+lead+'","mr_voip":"'+mrvoip+'","has_contact":"'+has_contact+'","has_sms":"'+has_sms+'","sms_type":"'+postpaid+'","has_chat":"'+has_chat+'","has_whatsapp":"'+has_whatsapp+'","has_fb":"'+has_fb+'","reseller":"'+reseller+'","has_fax":"'+has_fax+'","has_wechat":"'+has_wechat+'","has_telegram":"'+has_telegram+'","has_webinar":"'+has_webinar+'","voice_manage":"'+has_rec_manage+'","queue":"'+has_queue+'","has_internal_ticket":"'+has_internal_ticket+'","has_external_ticket":"'+has_external_ticket+'","has_internal_chat":"'+has_internal_chat+'","baisc_wallboard":"'+baisc_wallboard+'","wallboard_one":"'+wallboard_one+'","wallboard_two":"'+wallboard_two+'","wallboard_three":"'+wallboard_three+'","wallboard_four":"'+wallboard_four+'","wallboard_five":"'+wallboard_five+'","wallboard_six":"'+wallboard_six+'","wallboard_eight":"'+wallboard_eight+'","wallboard_nine":"'+wallboard_nine+'","two_factor":"'+two_factor+'","admin_status":"'+admin_status+'","has_chatbot":"'+has_chatbot+'","notes":"'+agent_req.notes+'","plan_id":"'+plan_id+'","call_rate":"'+call_rate+'","valid_from":"'+valid_from+'","valid_to":"'+valid_to+'","call_prefix":"'+call_prefix+'","tax_name":"'+tax_name+'","tax_per":"'+tax_per+'","post_url":"'+add_post_url+'","license_key":"'+license_key+'"}}';

this.serverService.sendServer(api_req).subscribe((response:any) => {
if(response.result.data == 1){
$('#add_node_user').modal('hide');
this.addNodeAadmin.reset();
 this.admin_settings();
 this.getNodelicense();

iziToast.success({
    message: "Admin created successfully",
    position: 'topRight'
});
}  else if(response.result.data == 3){
  iziToast.warning({
    message: "Admin name already in use",
    position: 'topRight'
});

} else{
  
iziToast.warning({
message: "Admin data could not retrive. Please try again",
position: 'topRight'
});

}
}, 
(error)=>{
console.log(error);
});
}
sendWelcomeMail(id,email,automation_admin,pbx_url,company_name){ 
  Swal.fire({
    title: 'Please Confirm',
    text: "Do you want to send the welcome Email to the customer",
    icon: 'info',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes!'
  }).then((result) => {
    if (result.value) {
 
      Swal.fire({
        title: 'Please Wait',
        allowEscapeKey: false,
        allowOutsideClick: false,
      //  background: '#19191a',
        showConfirmButton: false,
        onOpen: ()=>{
            Swal.showLoading();
        }
      });
    
       let access_token: any=localStorage.getItem('access_token');
    
      if(email == 'null' || email == null){
        iziToast.warning({
          message: "Please update email address to send welcome email",
          position: 'topRight'
      });
      return false;
      }
      let api_req:any ='';
    if(automation_admin=='1'){
       api_req = '{"operation":"agents", "moduleType":"agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"welcome_email_for_automation","user_id":"2","email":"'+email+'","pbx_url":"'+pbx_url+'"}}';
       this.serverService.welcomeEmailAutomation(api_req,company_name).subscribe((response:any) => {
        if(response.status==true){
          this.closeLoading();
          iziToast.success({
            message: "Automation Welcome Email Sent Successfully",
            position: 'topRight'
        });
        } else {
          this.closeLoading(); 
          iziToast.warning({
            message: "Sorry,Mail not sent",
            position: 'topRight'
        });
        }
      }, 
      (error)=>{
        this.closeLoading();
          console.log(error);
      });
    }else{ 
      api_req = '{"operation":"agents", "moduleType":"agents", "api_type": "web", "access_token":"'+access_token+'", "element_data":{"action":"welcome_email","user_id":"'+id+'","email":"'+email+'"}}';
      this.serverService.sendServer(api_req).subscribe((response:any) => {
        if(response.status==true){     
          this.closeLoading();
          iziToast.success({
            message: "Welcome Email Sent Successfully",
            position: 'topRight'
        });
        } else {
          this.closeLoading(); 
          iziToast.warning({
            message: "Sorry,Mail not sent",
            position: 'topRight'
        });
        }
      }, 
      (error)=>{
        this.closeLoading();
          console.log(error);
      });
    }
    }
  })

 
     
 

}

seedetailofadmin(queue){
  console.log(queue)
  
  if(queue.pbx_url_3cx != null){
    $('#det_pbx_url').empty();
    let text =queue.pbx_url_3cx;
    let result = text.link("https://"+queue.pbx_url_3cx+":4001");
    // console.log(result)
    // $('#det_pbx_url').html(result);
    var d1 = document.getElementById('det_pbx_url');
    let alinkTag = "<a style='color:red' href='https://"+queue.pbx_url_3cx+":4001' target='_blank'>"+queue.pbx_url_3cx+"</a>";
    $('#det_pbx_url').append(alinkTag);
 
    
  }else{
    $('#det_pbx_url').text(queue.pbx_url_3cx);
  }


  $('#det_comp_name').text(queue.company_name);
  $('#det_emailids').text(queue.email_id);
  $('#det_username').text(queue.user_name);
  $('#det_password').text(queue.password);
  $('#det_adminid').text(queue.admin_id);
  $('#det_notesValue').text(queue.notes);
  // $('#det_emailid').text(queue.email_id);
  let det_apiurl;
  if(queue.automation_admin=='1')
  det_apiurl='https://updates.mconnectapps.com/'+queue.company_name+'/api/v1.0/index.php';
  else
  det_apiurl='https://omni.mconnectapps.com/api/v1.0/index.php';
  $('#det_apiurl').text(det_apiurl);
  
  $("#showdetails").modal('show');
}

onChangeCategory(email:string, isChecked: boolean) {
    console.log(email);
    console.log(isChecked);
      if(isChecked) {
      this.reportsvalue.push(email);
    } else {
      // let index = this.reportsvalue.findIndex(x => x.value == email);
      // // let index = this.reportsvalue.indexof(x => x.value == email);
      // console.log(index);
      // this.reportsvalue.splice(index,1);

      const index = this.reportsvalue.findIndex(el => el === email)
      if (index > -1) {
        this.reportsvalue.splice(index, 1);
      }

    }

    console.log(this.reportsvalue);
  }

  checked(item){
    if(this.reportsvalue.indexOf(item) != -1){
      return true;
    }
  }
  checkeda_api(item){
    if(this.mrvoip_paid.indexOf(item)!=-1){
      return true;
    }
  }
  checkeds(item){
    if(this.mrvoip_v.indexOf(item) != -1){
      return true;
    }
  }
  api_check(item){
    if(this.mrvoip_v.indexOf(item) != -1){
      return true;
    }
  }
  onItemChange(value){
    console.log(" Value is : ", value );
    this.togleval=value;
 }
updatedProduction(companyName){ 
  

  let api_req:any = new Object();
  let agents_req:any = new Object();
  agents_req.action="changed_to_production";
  agents_req.company_name=companyName;
  api_req.operation="agents";
  api_req.moduleType="agents";
  api_req.api_type="web";
  agents_req.status=this.togleval;
  api_req.access_token=localStorage.getItem('access_token');
  api_req.element_data = agents_req;
  this.serverService.sendServer(api_req).subscribe((response:any) => {

    iziToast.success({
      message: "Successfully Moved To Production",
      position: 'topRight'
  });
    
    this.productionAdminSettings();
    this.demoAdminSettings();
    this.admin_settings();
    
    

  }, 
  (error)=>{
      console.log(error);
  });

}
notesReminder(){ 
  
  
  let api_req:any = new Object();
  let agents_req:any = new Object();
  agents_req.action="add_admin_note_remainder";
  agents_req.notes=this.noteseminder_notes;
  agents_req.company_name=this.noteseminder_company_name;
  api_req.operation="agents";
  api_req.moduleType="agents";
  api_req.api_type="web";
  api_req.access_token=localStorage.getItem('access_token');
  api_req.element_data = agents_req;
  this.serverService.sendServer(api_req).subscribe((response:any) => {
    if (response.status == true) {
    iziToast.success({
      message: "Successfully Added To Notes",
      position: 'topRight'
  });
  this.getNotes();
  this.productionAdminSettings();
  this.demoAdminSettings();
  this.admin_settings();
  $("#generalFilter").collapse('hide');
  this.noteseminder_notes = '';
}
  }, 
  (error)=>{
      console.log(error);
  });

}


toggleFunction(index){

    // this.selectedIndex = index;

  $('#target_'+index).toggle('slow');
  $(this).next("#target_"+index).stop().slideToggle(300);
}
producttoggleFunction(index){

  this.selectedIndex = index;
$(this).next("#producttarget_"+index).stop().slideToggle(300);
$('#producttarget_'+index).toggle('slow');


}
demotoggleFunction(index){

  this.selectedIndex = index;
$(this).next("#demotarget_"+index).stop().slideToggle(300);
$('#demotarget_'+index).toggle('slow');

}

productionAdminSettings(){
  let userId: any=localStorage.getItem('userId');
  let access_token: any=localStorage.getItem('access_token');
  let api_req:any = '{"operation":"agents", "moduleType":"agents", "api_type":"web", "access_token":"'+access_token+'", "element_data":{"action":"get_prod_admin_settings","user_id":"'+userId+'"}}';

  this.serverService.sendServer(api_req).subscribe((response:any) => {
    if(response.result.data.length != 0){
 
      this.adminProduction = response.result.data;
      this.prodrecordNotFound = false;
    } else {
      this.prodrecordNotFound = true;
    }
  }, 
  (error)=>{
      console.log(error);
  });
}

demoAdminSettings(){
  let userId: any=localStorage.getItem('userId');
  let access_token: any=localStorage.getItem('access_token');
  let api_req:any = '{"operation":"agents", "moduleType":"agents", "api_type":"web", "access_token":"'+access_token+'", "element_data":{"action":"get_demo_admin_settings","user_id":"'+userId+'"}}';

  this.serverService.sendServer(api_req).subscribe((response:any) => {
    if(response.result.data.length != 0){
 
      this.adminDemo = response.result.data;
      this.demorecordNotFound = false;
    } else {
      this.demorecordNotFound = true;
    }
  }, 
  (error)=>{
      console.log(error);
  });
}
getNotes(){
  let api_req:any = new Object();
  let agents_req:any = new Object();
  agents_req.action="get_admin_note";
  agents_req.company_name=this.noteseminder_company_name;
  api_req.operation="agents";
  api_req.moduleType="agents";
  api_req.api_type="web";
  api_req.access_token=localStorage.getItem('access_token');
  api_req.element_data = agents_req;
  this.serverService.sendServer(api_req).subscribe((response:any) => {
    if(response.result.data.length != 0){ 
 
      this.get_notes = response.result.data;
      console.log(this.get_notes);
      this.notesrecordNotFound = false;
    } else {
      this.get_notes= [];
      this.notesrecordNotFound = true;
    }
    
  }, 
  (error)=>{
      console.log(error);
  });
}

showChatPopup(id,automation_admin,company_name){
  this.noteseminder_company_name = company_name;
  $("#shownotesdetails").modal('show');
  console.log(company_name);
  this.getNotes();
}



}
